export default [["fr-fr", {
  "adverse-event": {
    "abdominal-pain": "Douleurs abdominales",
    "anorexia": "Anorexie",
    "areflexia": "Perte de réflexes",
    "articular-pain": "Douleurs articulaires ou musculaires",
    "ataxy": "Aggravation des troubles de l'équilibre et de la coordination (ataxie)",
    "atrophy": "Atrophie des muscles (perte de masse musculaire)",
    "bleeding": "Saignements",
    "blotch": "Marbrures",
    "breathlessness": "Essoufflement",
    "bruising": "Hématomes/ecchymoses",
    "changing-mood": "Humeur changeante",
    "chest-pain": "Douleur thoracique",
    "concentration-impairment": "Trouble de concentration",
    "confusion": "Confusion",
    "constipation": "Constipation",
    "cough": "Gêne respiratoire, toux",
    "cramps": "Crampes",
    "depression": "Dépression",
    "diarrhea": "Diarrhée",
    "diarrhea-nausea-following-treatments": "Diarrhée, nausées suivant la prise du traitement",
    "difficulty-swallowing": "Difficultés à avaler",
    "discomfort-when-changing-position": "Malaises lors de changements de position",
    "discrete-values": {
      "morning-stiffness": {
        "0": "< 30 mn",
        "1": "1h",
        "2": "2h",
        "3": "3h",
        "4": "≥ 4h"
      }
    },
    "dizziness": "Étourdissements",
    "drowsiness": "Somnolence",
    "falls": "Chutes",
    "fatigue": "Fatigue",
    "feelings": "Sensations altérées (engourdissement, picotement)",
    "fever": "Fièvre",
    "flush": "Bouffées de chaleur",
    "general-pain": "Douleurs générales",
    "handspain": "Douleurs dans la paume des mains",
    "headache": "Maux de tête",
    "hoarseness": "Enrouement",
    "hyperreflexia": "Exagération des réflexes",
    "infection": "Infections",
    "injection-point-pain": "Douleurs au point d'injection",
    "injection-point-skin-rash": "Éruption cutanée au point d'injection",
    "joint-pain": "Douleurs articulaires",
    "labels": {
      "morning-stiffness": "Quelle est la durée de vos raideurs matinales ?",
      "other": "Quel est votre degré de gêne ou de douleur ?"
    },
    "lackappetite": "Perte d'appétit",
    "liver-pain": "Douleur au foie",
    "loss-of-appetite": "Perte d'appétit",
    "memory-problems": "Troubles de la mémoire",
    "morning-stiffness": "Raideur matinale",
    "mouth-sores": "Plaies dans la bouche",
    "mouth-ulcers": "Aphtes",
    "movement": "Difficultés à marcher, à utiliser les jambes, les bras et les mains",
    "muscle-contraction": "Contraction musculaire",
    "muscle-pain": "Douleurs musculaires",
    "muscle-weakness": "Faiblesse musculaire",
    "nail-infection": "Infection de l'ongle",
    "nausea": "Nausée",
    "nocturnal-awakening": "Réveil nocturne",
    "nose-bleeding": "Saignement de nez",
    "ocular-oral-dryness": "Sécheresse oculaire ou buccale",
    "oedema": "Oedème",
    "oral-bleeding-bubble": "Bulle hémorragique endo-buccale",
    "other": "Autre",
    "outbreak": "Boutons et plaques",
    "pain": "Douleurs",
    "painful-urination": "Douleurs mictionnelles",
    "palmar-plantar": "Syndrôme main-pied",
    "palpitation": "Palpitations",
    "paralysis": "Paralysie",
    "petechiae": "Pétéchies",
    "redness-itching": "Rougeur, démangeaison",
    "respiratory-difficulty": "Difficultés respiratoires",
    "shiver": "Frissons",
    "skin-rash": "Éruption cutanée",
    "sleep-disorders": "Troubles du sommeil",
    "slowed-sensation": "Sensation de ralentissement",
    "sore-throat": "Gorge irritée",
    "spit-change": "Modification des crachats",
    "stomach-pain": "Maux de ventre",
    "tremble": "Tremblements",
    "urine": "Sang dans les urines",
    "vertigo": "Vertige",
    "vomiting": "Vomissements",
    "weightinc": "Prise de poids",
    "wheezing": "Respiration sifflante",
    "wound": "Plaies et brûlures dans la bouche"
  },
  "alert": {
    "alert-type": {
      "biological": "Alerte biologie",
      "clinical": "Alerte clinique",
      "journey": "Alerte de parcours",
      "mrc-stage-change-4": "Alerte stade MRC",
      "mrc-stage-change-5": "Alerte stade MRC",
      "predictor": "Alerte de l'arbre de décision"
    },
    "journey": {
      "discharge-form": "Fiche de sortie d'étude clinique à compléter",
      "treatment-compliance": "Pas de passage en pharmacie depuis plus d'1 mois"
    },
    "processing": {
      "type": {
        "irrelevant": "Alerte erronée",
        "processing": "En cours",
        "send-mici-surveys": "Questionnaires envoyés",
        "treated": "Alerte traitée"
      }
    },
    "sub-type": {
      "clinical": {
        "adverse-event": "Alerte symptôme",
        "blood-pressure": "Alerte tension",
        "crohn": "Alerte Crohn",
        "eva": "Alerte EVA",
        "ibd-disk": "Alerte IBD-Disk",
        "rch": "Alerte RCH",
        "vital-sign": "Alerte signe vital",
        "weight": "Alerte poids"
      },
      "journey": {
        "pills-refill": "Ordonnance médicamenteuse non renouvelée"
      }
    },
    "trigger": {
      "key": {
        "adverse-event-eva-score": "{adverseEventName} - EVA {value}",
        "alat": "ALAT : {value} UI/L",
        "anxiety-eva": "EVA anxiété : {value}",
        "asat": "ASAT : {value} UI/L",
        "bicarbonates": "Bicarbonates : {value} mmol/L",
        "calcium": "Calcium : {value} mmol/L",
        "creatinine": "Creatinine : {value} µmol/L",
        "creatinine-decrease": "Le taux de créatinine a diminué de {variation_that_triggered, number, ::percent} depuis la dernière mesure.",
        "creatinine-increase": "Le taux de créatinine a augmenté de {variation_that_triggered, number, ::percent} depuis la dernière mesure.",
        "crp": "CRP : {value} mg/L",
        "cyclosporine": "Ciclosporine : {value} µg/L",
        "decision-path": "Catégorie patient : {result}",
        "diastolic": "Pression diastolique : {value} mmHg",
        "energy-eva": "EVA énergie physique : {value}",
        "everolimus": "Évérolimus : {value} ng/mL",
        "hemoglobin": "Hémoglobine : {value} g/100mL",
        "hemoglobin-decrease": "Le taux d'hémoglobin a diminué de {variation_that_triggered, number, ::percent} depuis la dernière mesure.",
        "irritability-eva": "EVA irritabilité : {value}",
        "leukocytes": "Leucocytes : {value} G/L",
        "mood-eva": "EVA humeur : {value}",
        "neutrophils": "Polynucléaires neutrophiles : {value} G/L",
        "potassium": "Potassium : {value} mmol/L",
        "sirolimus": "Sirolimus : {value} ng/mL",
        "sleep-duration-eva": "EVA durée de sommeil : {value}",
        "systolic": "Pression systolique : {value} mmHg",
        "tacrolimus": "Tacrolimus : {value} ng/mL",
        "temperature": "Temperature : {value} °C",
        "weight": "Forte augmentation (ou diminution) du poids du patient ({value} kg) en moins de deux mois.",
        "weight-long-term": "Perte de poids sur les 6 derniers mois (%)"
      }
    }
  },
  "anxiety": {
    "questions": {
      "calm": "Je suis d'un grand calme",
      "confidence": "Je manque de confiance en moi",
      "decisions": "Prendre des décisions m'est facile",
      "disappointment": "Je prends les déceptions tellement à coeur que je n'arrive pas à les chasser de mon esprit",
      "equalTo": "Je sens que je ne suis pas à la hauteur de la situation",
      "fail": "J'ai l'impression d'être un(e) raté(e)",
      "happinessOthers": "Je voudrais être aussi heureux(se) que les autres semblent l'être",
      "happy": "Je suis heureux(se)",
      "happyMyself": "Je me sens content(e) de moi-même",
      "ideasWithoutImportance": "Des idées sans importance me passent par la tête et me tracassent",
      "nervous": "Je me sens nerveux(se) et agité(e)",
      "overcome": "Je sens que les difficultés s'accumulent au point où je n'arrive pas à les surmonter",
      "overreact": "Je m'en fais trop pour des choses qui n'en valent pas vraiment la peine",
      "preoccupied": "Je deviens tendu(e) ou bouleversé(e) quand je songe à mes préoccupations et à mes intérêts récents",
      "rested": "Je me sens reposé(e)",
      "satisfaction": "Je suis satisfait(e)",
      "security": "Je me sens en sécurité",
      "solidNerves": "Je suis une personne qui a les nerfs solides",
      "troubledThoughts": "J'ai des pensées troublantes",
      "willingness": "Je me sens dans de bonnes dispositions"
    }
  },
  "atc": {
    "B03X": "Prise d'un traitement anti-anémique (hors fer, vitamine B12, folates)"
  },
  "bio-exam-observation": {
    "specimen": {
      "AMN": "Liquide amniotique",
      "BBL": "Poche de sang",
      "BBL|BLD": "Poche de sang / Sanguin",
      "BLD": "Sanguin",
      "BLDA": "Sanguin artériel",
      "BLDC": "Sanguin capillaire",
      "BLDCO": "Sanguin Cordon",
      "BLDV": "Sanguin Veineux",
      "BLD|UR": "Sanguin / urinaire",
      "BRO": "Bronche",
      "BRO|NOSE|SPTT|SPTC": "Bronche / Nasal / Crachat - aspiration trachée / Crachat - toux",
      "BRO|SPT|SPTC": "Bronche / Nasal / Crachat - aspiration trachée / Crachat - toux",
      "CSF": "Liquide céphalo-rachidien",
      "EYE": "Occulaire",
      "FLU": "Fluide corporel",
      "GEN": "Génital",
      "ISLT": "Isolat",
      "LIQ|TISS": "Liquide, non spécifié / Tissu",
      "MAR": "Moëlle osseuse",
      "MAR|BLD": "Moëlle osseuse / Sanguin",
      "NOSE": "Nasal",
      "NOSE|BRO": "Nasal / Bronche",
      "PLR": "Liquide pleural",
      "PUS": "Pus",
      "SAL": "Salivaire",
      "SER": "Serum",
      "SMN": "Fluide séminal",
      "SNV": "Fluide sinovial",
      "SPTT|BRO|NOSE|SPTC|SPT": "Crachat - aspiration trachée",
      "SPT|BRO|NOSE|SPTC": "Crachat - toux",
      "STL": "Selles",
      "THRT": "Gorge",
      "UR": "Urinaire",
      "URTH": "Urètre",
      "UR|BLD": "Urinaire / Sanguin"
    }
  },
  "bio-exam-order": {
    "specimen": {
      "blood": "sanguin",
      "other": "autre",
      "urinary": "urinaire"
    }
  },
  "bioExamResultCodes": {
    "fileAttachments": {
      "HPRIM": "{count, plural,\n  one {1 HPRIM}\n  other {{count} HPRIMs}\n}\n",
      "PDF": "{count, plural,\n  one {1 PDF}\n  other {{count} PDFs}\n}\n",
      "image": "{count, plural,\n  one {1 image}\n  other {{count} images}\n}\n"
    },
    "showCorrection": "Correction d'un bilan existant",
    "unknownResults": "{count, plural,\n one {1 résultat non reconnu}\n other {{count} résultats non reconnus}\n}\n",
    "value": "{value, select,\n  positive {Positif}\n  negative {Negatif}\n  other {{value}}\n}\n"
  },
  "bioExamResults": {
    "blood": "Résultats sanguins",
    "other": "Autres résultats",
    "urinary": "Résultats urinaires"
  },
  "bone-erosion": {
    "erosive": "Érosive",
    "non-erosive": "Non-érosive"
  },
  "careGiver": {
    "role": {
      "acupuncturist": "Acupuncteur",
      "administrative": "Administratif",
      "algologist": "Algologue",
      "anaesthetist": "Anesthésiste",
      "analistique-laboratory": "Laboratoire d'analyse",
      "anatomopathologist": "APA",
      "angiologist": "Angiologue",
      "announcement-nurse": "Infirmière d'annonce",
      "association": "Association",
      "attending-surgeon": "Chirurgien traitant",
      "biologist": "Biologiste",
      "cardiologist": "Cardiologue",
      "caregiver": "Aidant",
      "dental-surgeon": "Chirurgien-dentiste",
      "dermograph-tattooer": "Tatoueur-Dermographe",
      "diabetologist-endocrinologist": "Diabétologue / endocrinologue",
      "dietician": "Diététicienne",
      "doctor": "Médecin traitant",
      "endocrinologist": "Endocrinologue",
      "esthetics-and-laser-doctor": "Médecin esthétique et laser",
      "geriatrician-doctor": "Médecin Gériatre",
      "gynecologist": "Gynécologue",
      "historicNurse": "Infirmière",
      "homeopath": "Homéopathe",
      "hypnotherapist": "Hypnothérapeute",
      "magnetizer": "Magnétiseur",
      "medicalDoctor": "Médecin généraliste",
      "midwife": "Sage-femme",
      "mim": "MIM",
      "naturopath": "Naturopathe",
      "nephrologist": "Néphrologue",
      "neurologist": "Neurologue",
      "nuclear-doctor": "Médecin nucléaire",
      "nurse": "Infirmier",
      "nurse-coordinator": "Infirmière coordinatrice",
      "nutritionist": "Nutritionniste",
      "oncologist": "Oncologue",
      "oncology-secretariat": "Secrétariat oncologie",
      "osteopath": "Ostéopathe",
      "other": "Autre",
      "pathway-coordinator": "Coordinatrice de Parcours",
      "pharmacist": "Pharmacien",
      "physiotherapist": "Kinésithérapeute",
      "private-nurse": "Infirmière libérale",
      "provider": "Prestataire",
      "psad": "PSAD",
      "psychiatrist": "Psychiatre",
      "psychologist": "Psychologue",
      "pulmonologist": "Pneumologue",
      "radiologist": "Radiologue",
      "radiotherapist": "Radiothérapeute",
      "reflexologist": "Réflexologue",
      "relative": "Proche du patient / aidant",
      "sexologist": "Sexologue",
      "social-worker": "Assistante sociale",
      "socio-esthetician": "Socio-esthéticienne",
      "sophrologist": "Sophrologue",
      "surgeon": "Chirurgien",
      "surgery-secretariat": "Secrétariat chirurgie"
    }
  },
  "chat": {
    "interlocutors": {
      "doctor": "dr",
      "patient": "le patient",
      "program": "le programme",
      "sender": "vous"
    }
  },
  "chemotherapy-protocol": {
    "12-taxol-3-ec": "12 Taxol + 3 EC",
    "12-weekly-taxol": "12 Taxol hebdomadaire",
    "3-ec-9-weekly-taxol": "3 EC + 9 Taxol hebdomadaire",
    "3-fec-100-12": "3 FEC 100 + 12",
    "3-fec-100-3-taxotere": "3 FEC 100 + 3 Taxotère",
    "3-fec-100-9-weekly-taxol": "3 FEC 100 + 9 Taxol hebdomadaire",
    "4-ec-9-taxol": "4 EC + 9 TAXOL",
    "4-tc": "4 TC",
    "6-ec-9-taxol": "6 EC + 9 TAXOL",
    "6-taxotere": "6 Taxotère"
  },
  "cnam-services-access-form": {
    "loading": {
      "allow-practice-location-modifications": "Nous modifions la situation d'exercice.",
      "authorize-medic": "Nous tentons d'autoriser l'accès au DMP.",
      "check-authentication": "Nous vérifions le statut d'authentification.",
      "check-documents": "Nous vérifions les documents d'identité du patient.",
      "check-installation-dmpconnect-js": "Nous vérifions l'installation de DmpConnectJS.",
      "check-rates": "Nous vérifions le nombre de précédents accès à l'historique de remboursement.",
      "check-valid-billing-number": "Nous validons les informations de facturation de la carte CPS.",
      "create-connector": "Nous créons le connecteur DMP.",
      "find-documents": "Nous recherchons les documents DMP liés au patient.",
      "ins-qualification-needed": "Nous tentons de qualifier l'identité du patient",
      "load-links": "Nous récupérons les liens de connexion.",
      "open-session": "Nous tentons l'ouverture d'une session.",
      "other": "",
      "read-cps": "Nous tentons une lecture de la carte CPx.",
      "retrieve-and-save-documents": "Nous tentons une récupération du contenu des documents du DMP.",
      "retrieve-and-save-latest-reimbursements-document": "Nous tentons une récupération de l'historique de remboursement.",
      "retrieve-ins": "Nous tentons de qualifier l'identité du patient.",
      "save-identity": "Nous sauvegardons l'identité du patient.",
      "save-operations": "Nous sauvegardons les informations récupérées.",
      "set-pin-code-and-computer-settings": "Nous récupérons les informations de la carte CPx.",
      "set-practice-location": "Nous appliquons la configuration de la situation d'exercice.",
      "set-secret-connection": "Nous appliquons la connexion secrète.",
      "show-document": "Nous récupérons le contenu du document DMP.",
      "validate-patient": "Nous validons les informations administratives du patient."
    },
    "success": {
      "text": {
        "dmp-retrieval": "L'historique de remboursement du patient a bien été mis à jour.",
        "ins": "L'identité du patient a bien été mise à jour."
      },
      "title": {
        "dmp-retrieval": "Téléchargement réussi",
        "ins": "Mise à jour de l'identité"
      }
    }
  },
  "comorbidity": {
    "icd10": {
      "A00-B99": "Certaines maladies infectieuses et parasitaires",
      "B02": "Zona [herpes zoster]",
      "B15.9": "Hépatite A",
      "B16": "Hépatite B",
      "B17.0": "Virus Hépatite D",
      "B18.2": "Hépatite C",
      "C18": "Cancer du côlon",
      "C22.0": "Carcinome hépatocellulaire",
      "C34": "Cancer du poumon",
      "C44": "Cancer de la peau",
      "C50": "Cancer du sein",
      "C61": "Cancer de la prostate",
      "C64": "Cancer du rein",
      "C67": "Cancer de la vessie",
      "C71": "Tumeur maligne de l'encéphale [Tumeur du cerveau]",
      "C95": "Leucémie à cellules non précisées",
      "Cardiovascular": "Comorbidités cardio-vasculaires",
      "D50-D89": "Maladies du sang et des organes hématopoïétiques et certains troubles impliquant le mécanisme immunitaire",
      "D86": "Sarcoïdose",
      "Digestive": "Comorbidités digestives",
      "E03.9": "Hypothyroïdie",
      "E05": "Hyperthyroïdie",
      "E10": "Diabète type 1",
      "E11": "Diabète type 2",
      "E66": "Obésité",
      "E70-E90": "Anomalies du métabolisme",
      "E78": "Anomalies du métabolisme des lipoprotéines et autres lipidémies",
      "E78.5": "Hyperlipidémie, sans précision",
      "E78.9": "Anomalie du métabolisme des lipoprotéines, sans précision",
      "E84.0": "Fibrose kystique avec manifestations pulmonaires",
      "E88.9": "Anomalie métabolique, sans précision",
      "Endocrine": "Comorbidités endocriniennes",
      "F03": "Démence",
      "F10": "Troubles mentaux et du comportement liés à l'utilisation d'alcool",
      "F10-F19": "Troubles mentaux et du comportement liés à l'utilisation de substances psycho-actives",
      "F10.24": "Syndrome de dépendance à l'alcool, utilisation actuelle",
      "F12": "Troubles mentaux et du comportement liés à l'utilisation de dérivés du cannabis",
      "F17": "Troubles mentaux et du comportement liés à l'utilisation de tabac",
      "F17.24": "Syndrome de dépendance au tabac, utilisation actuelle",
      "F30-F39": "Troubles de l'humeur affectifs",
      "F33": "Troubles dépressifs récurrents",
      "F34": "Troubles de l’humeur persistants",
      "F40-F48": "Troubles névrotiques, troubles liés à des facteurs de stress et troubles somatoformes",
      "F40.0": "Agoraphobie",
      "F40.1": "Phobies sociales",
      "F40.2": "Phobies spécifiques (isolées)",
      "F41.0": "Trouble panique [anxiété épisodique paroxystique]",
      "F41.1": "Anxiété généralisée",
      "F42.9": "Trouble obsessionnel-compulsif, sans précision",
      "F43.1": "Etat de stress post-traumatique",
      "F90-F98": "Troubles du comportement et troubles émotionnels apparaissant habituellement durant l'enfance et l'adolescence",
      "F90.0": "Perturbation de l'activité et de l'attention",
      "G12.2": "Maladie du neurone moteur (maladie de Charcot)",
      "G20": "Parkinson",
      "G30": "Alzheimer",
      "G35": "Sclérose en plaques",
      "G45.9": "Accident ischémique cérébral transitoire (AIT)",
      "G47.3": "Apnée du sommeil",
      "G89-G99": "Autres troubles du système nerveux",
      "G99.0": "Neuropathie du système nerveux autonome au cours de maladies endocriniennes et métaboliques",
      "H30-H36": "Troubles de la choroïde et de la rétine",
      "H36": "Rétinopathie",
      "I00-I99": "Maladies du système circulatoire",
      "I10": "Hypertension artérielle (HTA)",
      "I11": "Cardiopathie hypertensive",
      "I21": "Infarctus aigu du myocarde",
      "I24": "Thrombose coronaire",
      "I24.9": "Cardiopathie ischémique",
      "I30-I52": "Autres formes de cardiopathies",
      "I35.0": "Sténose (de la valvule) aortique",
      "I48": "Fibrillation auriculaire",
      "I49.9": "Arythmie cardiaque, sans précision",
      "I50.9": "Insuffisance cardiaque autre origine",
      "I51.6": "Maladies cardiovasculaires avérées",
      "I60-I69": "Maladies cérébrovasculaires",
      "I64": "Accident vasculaire cérébral (AVC)",
      "I70": "Athérosclérose",
      "I71.4": "Anévrysme aorte abdominale",
      "I73.9": "Artériopathie oblitérante des membres inférieurs",
      "I77.0": "Fistule artérioveineuse, acquise",
      "I81": "Thrombose de la veine porte",
      "J42": "BPCO",
      "J45": "Asthme",
      "J47": "Dilatation des bronches",
      "K27": "Ulcère gastro-duodénal",
      "K51": "Recto-colite hémorragique",
      "K52.9": "MICI",
      "K74": "Fibrose et cirrhose du foie",
      "K76.9": "Hépatopathie",
      "K83.0": "Angiocholite [cholangite]",
      "K900": "Maladie coeliaque",
      "L00-L99": "Maladies de la peau et du tissu sous-cutané",
      "L85.8": "Autres formes précisées d'épaississement de l'épiderme",
      "L93": "Lupus érythémateux",
      "M19.9": "Arthrose",
      "M81.9": "Ostéoporose",
      "N18.0": "Insuffisance rénale chronique stade terminal",
      "N18.4": "Maladies rénales chroniques, stade IV",
      "N18.5": "Maladies rénales chroniques stade V",
      "N18.9": "Maladies rénales chroniques",
      "N28.1": "Kyste rénal",
      "N40": "Hypertrophie prostatique",
      "NeoplasticAntecedents": "Antécédents néoplasiques",
      "Neurologic": "Comorbidités neurologiques",
      "Osteo": "Comorbidités ostéo-articulaires",
      "Q62.1": "Sténose de l'urètre",
      "Q62.7": "Reflux vésico-urétéral",
      "Respiratory": "Comorbidités respiratoires",
      "T14.2": "Fracture",
      "Urologic": "Comorbidités urologiques",
      "Z00-Z99": "Facteurs influençant l'état de santé et le contact avec les services de santé",
      "Z72.3": "Difficultés liées au manque d'exercice physique",
      "Z95.0": "Présence pacemaker",
      "Z99.1": "Dépendance envers un respirateur",
      "other": "Autres comorbidités sévères"
    }
  },
  "consultation-frequency": {
    "frequency": {
      "1-day": "Tous les jours",
      "1-month": "Tous les mois",
      "1-week": "Toutes les semaines",
      "1-year": "Tous les ans",
      "2-day": "Tous les deux jours",
      "2-month": "Tous les deux mois",
      "2-week": "Toutes les deux semaines",
      "2-year": "Tous les deux ans",
      "3-day": "Deux fois par semaine",
      "3-month": "Tous les trois mois",
      "3-year": "Tous les trois ans",
      "4-month": "Tous les quatre mois",
      "5-month": "Tous les cinq mois",
      "5-year": "Tous les cinq ans",
      "6-month": "Tous les six mois",
      "never": "Jamais"
    },
    "specialty": {
      "addictologist": "Addictologue",
      "cardiologist": "Cardiologue",
      "child-psychiatrist": "Pédopsychiatre",
      "chiropodist-podiatrist": "Pédicure-podologue",
      "dentist": "Dentiste",
      "dermatologist": "Dermatologue",
      "diabetologist": "Diabétologue",
      "diabetologist-endocrinologist": "Diabétologue-endocrinologue",
      "dietitian": "Diététicien",
      "doctor": "Médecin traitant",
      "gastroenterologist": "Gastroentérologue",
      "group-psychotherapy": "Psychothérapie de groupe",
      "gynecologist": "Gynécologue",
      "hematologist": "Hématologue",
      "hepatologist": "Hépatologue",
      "mpr": "MPR",
      "nephrologist": "Néphrologue",
      "neurologist": "Neurologue",
      "occupational-therapist": "Ergothérapeute",
      "oncologist": "Oncologue",
      "ophtalmologist": "Ophtalmologue",
      "orthopedist": "Othopédiste",
      "physiotherapist": "Kinésithérapeute",
      "psychiatrist": "Psychiatre",
      "psychologist": "Psychologue",
      "pulmonologist": "Pneumologue",
      "radiologist": "Radiologue",
      "radiotherapist": "Radiothérapeute",
      "rheumatologist": "Rhumatologue",
      "social-worker": "Assistant social",
      "surgeon": "Chirurgien",
      "urologist": "Urologue"
    }
  },
  "consultation-history": {
    "addictologist": "Addictologue",
    "allergist": "Allergologue",
    "ambulance-driver": "Ambulancier",
    "anatomy-cytology-pathology-doctor": "Médecin spécialiste en anatomie et cytologie pathologiques",
    "andrologist": "Andrologue",
    "audioprosthesist": "Audioprothésiste",
    "biologist": "Biologiste",
    "biologist-pharmacist": "Pharmacien biologiste",
    "cardiac-surgeon": "Chirurgien cardio-vasculaire",
    "cardiologist": "Cardiologue",
    "care-giver": "Aide soignant",
    "child-care-assistant": "Auxiliaire de puériculture",
    "child-psychiatrist": "Pédopsychiatre",
    "chiropodist": "Pédicure-podologue",
    "dental-assistant": "Assisstant dentaire",
    "dentist": "Dentiste",
    "dermatologist": "Dermatologue",
    "diabetologist": "Diabétologue",
    "diabetologist-endocrinologist": "Diabétologue-endocrinologue",
    "dietitian": "Diététicien",
    "doctor": "Médecin traitant",
    "emergency-doctor": "Médecin urgentiste",
    "epithesist": "Epithesiste",
    "forensic-doctor": "Médecin légiste",
    "gastroenterologist": "Gastroentérologue",
    "geneticist": "Généticien",
    "geriatrician": "Gériatre",
    "gynecologist": "Gynécologue",
    "hematologist": "Hématologue",
    "hemobiologist": "Hémobiologiste",
    "hepatologist": "Hépatologue",
    "hospital-pharmacist": "Pharmacien d'établissement",
    "immunologist": "Immunologue",
    "internal-medicine-doctor": "Médecin spécialiste en médecine interne",
    "ipa": "Infirmier en Pratique Avancée",
    "maxillofacial-surgeon": "Chirurgien maxillo-facial",
    "medical-biologist": "Médecin biologiste",
    "midwife": "Sage-Femme",
    "mpr": "MPR",
    "neonatalogist": "Néonatalogiste",
    "nephrologist": "Néphrologue",
    "neuro-psychiatrist": "Neuro-psychiatre",
    "neuro-surgeon": "Neuro-chirurgien",
    "neurologist": "Neurologue",
    "neuropathologist": "Neuropathologiste",
    "nuclear-medicine-doctor": "Médecin spécialiste en médecine nucléaire",
    "nurse": "Infirmier",
    "nutritionist": "Nutritioniste",
    "occupational-physician": "Médecin du travail",
    "occupational-therapist": "Ergothérapeute",
    "ocularist": "Oculariste",
    "oncologist": "Oncologue",
    "ophtalmologist": "Ophtalmologue",
    "optician": "Opticien / Lunetier",
    "orl-surgeon": "Chirurgien spécialisé en ORL",
    "ortho-surgeon": "Chirurgien orthopédique et traumatologique",
    "orthodentist": "Orhtodontiste",
    "orthopedist": "Othopédiste",
    "orthoprosthetist": "Orthoprothésiste",
    "orthoptist": "Orthoptiste",
    "other-consultations": "Autre consultations",
    "otolaryngologist": "ORL",
    "pain-medicine-doctor": "Médecin de la douleur",
    "pediatric-surgeon": "Chirurgien pédiatrique",
    "pediatrician": "Pédiatre",
    "phoniatrist": "Phoniatre",
    "physical-medicine-doctor": "Médecin spécialiste en médecine physique et réadaptation fonctionnelle",
    "physiotherapist": "Kinésithérapeute",
    "plastic-surgeon": "Chirurgien plastique",
    "podiatrist": "Podo-Orthésiste",
    "psychiatrist": "Psychiatre",
    "psychologist": "Psychologue",
    "psychomotrician": "Psychomotricien",
    "public-health-doctor": "Médecin de santé publique",
    "pulmonologist": "Pneumologue",
    "radio-pharmacist": "Radiopharmacien",
    "radiologist": "Radiologue",
    "radiotherapist": "Radiothérapeute",
    "reproductive-medicine-doctor": "Andrologue, urologue, sexologue",
    "resuscitator-doctor": "Médecin réanimateur",
    "retail-pharmacist": "Pharmacien d'officine",
    "rheumatologist": "Rhumatologue",
    "social-worker": "Assistante sociale",
    "speech-therapist": "Orthophoniste",
    "sports-medicine-doctor": "Médecin du sport",
    "stomatologist": "Stomatologue",
    "surgeon": "Chirurgien général",
    "thermal-doctor": "Médecin spécialiste en médecine thermale",
    "thoracic-surgeon": "Chirurgien thoracique",
    "tropical-disease-doctor": "Médecin spécialiste des maladies infectieuses et tropicales",
    "urological-surgeon": "Chirurgien urologue",
    "urologist": "Urologue",
    "vascular-doctor": "Médecin vasculaire",
    "visceral-digestive-surgeon": "Chirurgien digestif"
  },
  "consultation-report-types": {
    "addictologist": "Addictologue",
    "addictologist-consultation": "Consultation addictologue",
    "cardiologist-consultation": "Consultation cardiologue",
    "coordinator-follow-up-point": "Point de suivi coordinatrice de parcours",
    "diabetologist-consultation": "Consultation diabétologue-endocrinologue",
    "dietitian-assessment": "Evaluation de diététicien",
    "dietitian-consultation": "Consultation diététicien",
    "gastroenterologist-consultation": "Consultation gastro-entérologue",
    "group-psychotherapy": "Psychothérapie de groupe",
    "hepatologist-consultation": "Consultation hépatologue",
    "inclusion": "CR d'inclusion patient",
    "individual-psychotherapy": "Psychothérapie individuelle",
    "initial-interview": "Entretien de suivi initial",
    "life-hygiene-coaching": "Coaching hygiène de vie",
    "medical-imaging": "Examen d'imagerie",
    "mpr-consultation": "Consultation MPR",
    "nephrologist-consultation": "Consultation néphrologue",
    "neurologist-consultation": "Consultation neurologue",
    "nurse-assessment": "Évaluation avec un IDE",
    "occupational-therapist-consultation": "Consultation ergothérapeute",
    "oncologist-consultation": "Consultation oncologue",
    "ophthalmologist-consultation": "Consultation ophtalmologue",
    "orthopedist-consultation": "Consultation orthopédiste",
    "physiotherapist-consultation": "Consultation kinésithérapeute",
    "podiatrist-consultation": "Consultation pédicule-podologue",
    "ponctual-monitoring-point": "Point de suivi récurrent Case Manager",
    "psychiatrist": "Psychiatre",
    "psychologist": "Psychologue",
    "psychologist-interview": "Entretien avec un psychologue",
    "pulmonologist-consultation": "Consultation pneumologue",
    "radiotherapist-consultation": "Consultation radiothérapeute",
    "recurring-monitoring-point": "Point de suivi ponctuel Case Manager",
    "rheumatologist-consultation": "Consultation rhumatologue",
    "second-interview": "Entretien de suivi 2 - Gestion des effets indésirables",
    "social-worker-interview": "Entretien avec une assistante sociale",
    "surgeon-consultation": "Consultation chirurgien",
    "therapeutic-assistance": "Accompagnement thérapeutique",
    "therapeutic-education": "Séance d'éducation thérapeutique",
    "third-interview": "Entretien de suivi 3 - Observance"
  },
  "contact-preference": {
    "friday": "vendredi",
    "holidays": "jours fériés",
    "monday": "lundi",
    "saturday": "samedi",
    "sunday": "dimanche",
    "thursday": "jeudi",
    "tuesday": "mardi",
    "wednesday": "mercredi"
  },
  "creator": {
    "medic": {
      "doctor": "par le Dr {name}",
      "medical_secretary": "par secrétaire médicale {name}",
      "nurse": "par l'IDE {name}",
      "nurse_lead": "par l'IPA {name}",
      "research_assistant": "par l'attaché(e) de recherche clinique (ARC) {name}",
      "retail_pharmacist": "par le pharmacien {name}"
    }
  },
  "ctcae-custom": {
    "activityRecovery": {
      "answers": {
        "0": "Oui",
        "1": "Vous avez besoin d'assistance pour vous déplacer",
        "2": "Vous ne pouvez pas vous déplacer"
      },
      "long": "Avez-vous repris votre activité habituelle&nbsp;?",
      "short": "Récupération de l'activité"
    },
    "ambulatoryProcedure": {
      "answers": {
        "false": "Non, je refuse l'ambulatoire prévu et je contacte sans délai le 05.31.15.53.70",
        "true": "Oui"
      },
      "long": "Acceptez-vous, tel que prévu, la réalisation de cette procédure en ambulatoire&nbsp;?",
      "short": "Procédure ambulatoire acceptée"
    },
    "articularPainIssue": {
      "answers": {
        "false": "Non",
        "true": "Oui"
      },
      "long": "Avez-vous des douleurs articulaires&nbsp;?",
      "short": "Douleurs articulaires"
    },
    "articularPainLevel": {
      "answers": {
        "0": "Douleur légère",
        "1": "Douleur modérée avec faiblesse, interférant avec les activités instrumentales de la vie quotidienne",
        "2": "Douleur avec faiblesse sévère, interférant avec les activités élémentaires de la vie quotidienne"
      },
      "long": "À quelle intensité mesurez-vous vos douleurs articulaires&nbsp;?",
      "short": "Intensité douleurs articulaires"
    },
    "articularPainLocation": {
      "long": "Quelles sont les localisations de vos douleurs articulaires&nbsp;?",
      "short": "Localisations douleurs articulaires"
    },
    "articularPainTreatmentEfficient": {
      "answers": {
        "false": "Non",
        "true": "Oui"
      },
      "long": "Le traitement en cours est-il efficace&nbsp;?",
      "short": "Traitement douleurs articulaires efficace"
    },
    "attendantForReturn": {
      "answers": {
        "false": "Non",
        "true": "Oui"
      },
      "long": "Nous vous rappelons que la présence d'un accompagnant sera indispensable pour votre retour à domicile et pour la première nuit. Avez-vous organisé votre retour&nbsp;?",
      "short": "Présence d'un accompagnant"
    },
    "bleedingOnWound": {
      "answers": {
        "0": "Non",
        "1": "Oui, modéré (écoulement très faible de sang)",
        "2": "Oui, sévère (il existe un écoulement en continu au niveau de la plaie)"
      },
      "long": "Présentez-vous un saignement sur la zone opératoire (cicatrice ou au niveau du vagin)&nbsp;?",
      "short": "Saignement sur zone opératoire"
    },
    "boughtPainkillersAndAntinauseant": {
      "answers": {
        "false": "Si non, pensez à aller les chercher à votre pharmacie",
        "true": "Oui"
      },
      "long": "Avez-vous pensé à acheter les médicaments antalgiques et antinauséeux prescrits lors de la consultation d'anesthésie&nbsp;?",
      "short": "Achat antalgiques et antinauséeux"
    },
    "breath": {
      "answers": {
        "0": "Essoufflement pour des efforts soutenus (montée 2 étages)",
        "1": "Essoufflement lors de la marche rapide ou en pente",
        "2": "Essoufflement à la marche sur terrain plat, en suivant quelqu'un de votre âge ou nécessité de s'arrêter, en marchant à son rythme en terrain plat",
        "3": "Essoufflement obligeant à s'arrêter pour reprendre votre souffle après quelques minutes ou une centaine de mètres sur terrain plat",
        "4": "Essoufflement au moindre effort"
      },
      "long": "À quelle intensité mesurez-vous vos difficultés à respirer&nbsp;?",
      "short": "Intensité difficultés à respirer"
    },
    "breathIssue": {
      "answers": {
        "false": "Non",
        "true": "Oui"
      },
      "long": "Avez-vous des difficultés pour respirer&nbsp;?",
      "short": "Difficultés à respirer"
    },
    "calfPain": {
      "answers": {
        "false": "Non",
        "true": "Oui"
      },
      "long": "Avez vous une douleur dans un mollet&nbsp;?",
      "short": "Douleurs mollet"
    },
    "constipation": {
      "answers": {
        "0": "Occasionnellement, de façon intermittente",
        "1": "Constipation persistante malgré un usage régulier de laxatif(s)"
      },
      "long": "À quelle intensité évaluez-vous votre constipation&nbsp;?",
      "short": "Intensité troubles digestifs"
    },
    "constipationIssue": {
      "answers": {
        "false": "Non",
        "true": "Oui"
      },
      "long": "Êtes-vous constipé(e)&nbsp;?",
      "short": "Constipation"
    },
    "constipationTreatmentEfficient": {
      "answers": {
        "false": "Non",
        "true": "Oui"
      },
      "long": "Le traitement en cours est-il efficace&nbsp;?",
      "short": "Traitement constipation efficace"
    },
    "cortisone": {
      "answers": {
        "false": "Non",
        "true": "Oui"
      },
      "long": "Prenez-vous de la cortisone (Solupred ou Cortancyl) par voie orale&nbsp;?",
      "short": "Prise cortisone"
    },
    "cortisoneDosageGt20": {
      "answers": {
        "false": "Non",
        "true": "Oui"
      },
      "long": "Au moins 20 mg par jour&nbsp;?",
      "short": "Cortisone >20mg/jour"
    },
    "cough": {
      "answers": {
        "0": "Aucune",
        "1": "Légère",
        "2": "Modérée",
        "3": "Sévère",
        "4": "Très sévère"
      },
      "long": "À quelle sévérité mesurez-vous votre toux&nbsp;?",
      "short": "Sévérité toux"
    },
    "coughIssue": {
      "answers": {
        "false": "Non",
        "true": "Oui"
      },
      "long": "Avez-vous de la toux&nbsp;?",
      "short": "Toux"
    },
    "currentWeight": {
      "answers": "{ value } kg",
      "long": "Quel est votre poids actuel (en kgs)&nbsp;?",
      "short": "Poids"
    },
    "dermatologicalIssue": {
      "answers": {
        "false": "Non",
        "true": "Oui"
      },
      "long": "Avez-vous des troubles dermatologiques&nbsp;?",
      "short": "Troubles dermatologiques"
    },
    "dermatologicalTreatmentEfficient": {
      "answers": {
        "false": "Non",
        "true": "Oui"
      },
      "long": "Le traitement en cours est-il efficace&nbsp;?",
      "short": "Efficacité traitement dermatologique"
    },
    "diarrhea": {
      "answers": {
        "0": "Plus de 4 selles liquides /jour par rapport à votre transit de base",
        "1": "Majoration de 4 à 6 selles liquides / j par rapport à votre transit de base",
        "2": "Majoration < ou = 7 selles liquides /j par rapport à votre transit de base"
      },
      "long": "À quelle intensité évaluez-vous vos diarrhées&nbsp;?",
      "short": "Intensité diarrhées"
    },
    "diarrheaIssue": {
      "answers": {
        "false": "Non",
        "true": "Oui"
      },
      "long": "Avez-vous des diarrhées&nbsp;?",
      "short": "Diarrhées"
    },
    "diastolicBloodPressure": {
      "answers": {
        "0": ">= 95 mmHg",
        "1": "< 95 mmHg"
      },
      "long": "Quelle est votre pression artérielle diastolique&nbsp;?",
      "short": "Tension artérielle diastolique"
    },
    "difficultiesToUrinate": {
      "answers": {
        "0": "Non",
        "1": "Oui mais j'arrive quand même à uriner",
        "2": "Oui et je n'arrive pas du tout à uriner"
      },
      "long": "Avez-vous des difficultés pour uriner&nbsp;?",
      "short": "Difficultés à uriner"
    },
    "digestiveRecovery": {
      "answers": {
        "0": "Oui",
        "1": "Gaz présents mais pas de selles",
        "2": "Pas de gaz et pas de selles"
      },
      "long": "Avez-vous repris un transit digestif&nbsp;?",
      "short": "Récupération du transit"
    },
    "eatingRecovery": {
      "answers": {
        "0": "Semblable à la veille de l'intervention",
        "1": "Vous arrivez à manger et boire mais pas comme avant l'intervention",
        "2": "Vous n'arrivez pas à boire ou à manger"
      },
      "long": "Comment se passe votre reprise alimentaire&nbsp;?",
      "short": "Reprise de l'alimentation"
    },
    "fatigue": {
      "answers": {
        "0": "Fatigue légère, soulagée par le repos",
        "1": "Fatigue modérée, non soulagée par le repos, limitant certaines de vos activités quotidiennes",
        "2": "Fatigue sévère : compromettant les tâches de la vie quotidienne élémentaires, limitant les déplacements, les sorties"
      },
      "long": "À quelle intensité mesurez-vous votre fatigue&nbsp;?",
      "short": "Intensité fatigue"
    },
    "fatigueIssue": {
      "answers": {
        "false": "Non",
        "true": "Oui"
      },
      "long": "Vous sentez-vous fatigué(e)&nbsp;?",
      "short": "Fatigue"
    },
    "itchingIssue": {
      "answers": {
        "false": "Non",
        "true": "Oui"
      },
      "long": "Avez-vous des démangeaisons&nbsp;?",
      "short": "Démangeaisons"
    },
    "itchingLocation": {
      "long": "Quelles sont les localisations de vos démangeaisons&nbsp;?",
      "short": "Localisations démangeaisons"
    },
    "muscularPainIssue": {
      "answers": {
        "false": "Non",
        "true": "Oui"
      },
      "long": "Avez-vous des douleurs musculaires&nbsp;?",
      "short": "Douleurs musculaires"
    },
    "muscularPainLevel": {
      "answers": {
        "0": "Douleur légère",
        "1": "Douleur modérée avec faiblesse, interférant avec les activités instrumentales de la vie quotidienne",
        "2": "Douleur avec faiblesse sévère, interférant avec les activités élémentaires de la vie quotidienne"
      },
      "long": "À quelle intensité mesurez-vous vos douleurs musculaires&nbsp;?",
      "short": "Intensité douleurs musculaires"
    },
    "muscularPainLocation": {
      "long": "Quelles sont les localisations de vos douleurs musculaires&nbsp;?",
      "short": "Localisations douleurs musculaires"
    },
    "muscularPainTreatmentEfficient": {
      "answers": {
        "false": "Non",
        "true": "Oui"
      },
      "long": "Le traitement en cours est-il efficace&nbsp;?",
      "short": "Efficacité traitement douleurs musculaires"
    },
    "nauseaOrVomiting": {
      "answers": {
        "0": "Oui",
        "1": "Oui, minimes",
        "2": "Oui, modérés et le médicament prescrit est efficace",
        "3": "Oui, sévères et persistent malgré le traitement prescrit"
      },
      "long": "Présentez-vous des nausées ou des vomissements&nbsp;?",
      "short": "Nausées ou vomissements"
    },
    "nauseaVomiting": {
      "answers": {
        "0": "Perte d'appétit sans modification des habitudes alimentaires",
        "1": "Diminution des apports alimentaires sans perte de poids, déshydratation ou malnutrition",
        "2": "Apports caloriques ou hydriques insuffisants"
      },
      "long": "À quelle intensité évaluez-vous vos nausées ou vos vomissements&nbsp;?",
      "short": "Intensité nausées ou vomissements"
    },
    "nauseaVomitingIssue": {
      "answers": {
        "false": "Non",
        "true": "Oui"
      },
      "long": "Avez-vous des nausées ou des vomissements&nbsp;?",
      "short": "Nausées ou vomissements"
    },
    "otherPainIssue": {
      "answers": {
        "false": "Non",
        "true": "Oui"
      },
      "long": "Avez-vous d'autre(s) douleur(s)&nbsp;?",
      "short": "Autres douleurs"
    },
    "otherPainLocation": {
      "long": "Quelles sont les localisations de vos autres douleurs&nbsp;?",
      "short": "Localisations autres douleurs"
    },
    "otherPainTreatmentEfficient": {
      "answers": {
        "false": "Non",
        "true": "Oui"
      },
      "long": "Le traitement en cours est-il efficace&nbsp;?",
      "short": "Efficacité traitement autres douleurs"
    },
    "pacFlowing": {
      "answers": {
        "false": "Non",
        "true": "Oui"
      },
      "long": "Votre port-à-cath présente-il un écoulement&nbsp;?",
      "short": "Ecoulement port-à-cath"
    },
    "pacHealing": {
      "answers": {
        "false": "Non",
        "true": "Oui"
      },
      "long": "Votre port-à-cath présente-il des problèmes de cicatrisation&nbsp;?",
      "short": "Problèmes cicatrisation port-à-cath"
    },
    "pacInflammatory": {
      "answers": {
        "false": "Non",
        "true": "Oui"
      },
      "long": "Votre port-à-cath est-il inflammatoire&nbsp;?",
      "short": "Port-à-cath inflammatoire"
    },
    "pacPainful": {
      "answers": {
        "false": "Non",
        "true": "Oui"
      },
      "long": "Votre port-à-cath est-il douloureux&nbsp;?",
      "short": "Port-à-cath douloureux"
    },
    "pain": {
      "long": "Intensité de la douleur actuelle",
      "short": "Intensité douleur actuelle"
    },
    "painIssue": {
      "answers": {
        "false": "Non",
        "true": "Oui"
      },
      "long": "Avez-vous des douleurs&nbsp;?",
      "short": "Douleurs"
    },
    "painSinceBackHome": {
      "answers": {
        "0": "Pas de douleur ou douleur supportable (douleur entre 0 et 3 sur 10)",
        "1": "Oui mais les médicaments me soulagent (douleur entre 3 et 5 sur 10)",
        "2": "Oui et les médicaments ne me soulagent pas (douleur au delà de 5 sur 10)"
      },
      "long": "Avez-vous des douleurs depuis votre retour à la maison&nbsp;?",
      "short": "Douleurs après retour à domicile"
    },
    "pulse": {
      "answers": {
        "0": "< 50 bpm",
        "1": ">= 110 bpm",
        "2": "Entre 50 et 110 bpm"
      },
      "long": "Quel est votre pouls&nbsp;?",
      "short": "Pouls"
    },
    "radiotherapy": {
      "answers": {
        "false": "Non",
        "true": "Oui"
      },
      "long": "Avez-vous actuellement un traitement de radiothérapie en cours&nbsp;?",
      "short": "Traitement radiothérapie"
    },
    "skinRashIssue": {
      "answers": {
        "false": "Non",
        "true": "Oui"
      },
      "long": "Avez-vous des éruptions cutanées&nbsp;?",
      "short": "Éruptions cutanées"
    },
    "skinRashLocation": {
      "long": "Quelles sont les localisations de vos éruptions cutanées&nbsp;?",
      "short": "Localisations éruptions cutanées"
    },
    "systolicBloodPressure": {
      "answers": {
        "0": ">= 150 mmHg",
        "1": "< 150 mmHg"
      },
      "long": "Quelle est votre pression artérielle systolique&nbsp;?",
      "short": "Tension artérielle systolique"
    },
    "temperature": {
      "long": "Quelle est votre température (en °C)&nbsp;?",
      "short": "Température actuelle"
    },
    "temperatureIssue": {
      "answers": {
        "false": "Non",
        "true": "Oui"
      },
      "long": "Avez-vous ou avez-vous eu de la température&nbsp;?",
      "short": "Température"
    },
    "temperatureLevel": {
      "answers": {
        "0": "Non",
        "1": "Oui mais < 38°",
        "2": "Oui et > 38°"
      },
      "long": "Avez-vous une température supérieure à 37°C&nbsp;?",
      "short": "Fièvre"
    },
    "trustPersonSurveyFilled": {
      "answers": {
        "false": "Si non, merci de le faire avant votre admission",
        "true": "Oui"
      },
      "long": "Avez-vous pensé à remplir le papier désignant votre personne de confiance (Il est nécessaire de le remplir et de le ramener lors de votre hospitalisation) ?",
      "short": "Désignation personne de confiance réalisée"
    },
    "usualTreatmentGuidelines": {
      "answers": {
        "0": "Si oui, vous devez vous conformer aux informations données par l'anesthésiste concernant la gestion de vos traitements habituels les jours précédents et le matin de votre intervention",
        "1": "Non, j'ai un traitement mais pas de consigne",
        "2": "Non, pas de traitement habituel"
      },
      "long": "En cas de traitements habituels, avez-vous reçu des consignes particulières&nbsp;?",
      "short": "Consignes reçues si traitement habituels"
    },
    "weightLoss": {
      "answers": "{ value } kgs",
      "long": "Combien de kgs avez-vous perdu&nbsp;?",
      "short": "Combien de kgs perdus"
    },
    "weightLossIssue": {
      "answers": {
        "false": "Non",
        "true": "Oui"
      },
      "long": "Avez-vous perdu du poids&nbsp;?",
      "short": "Perte de poids"
    },
    "woundFlow": {
      "answers": {
        "false": "Non",
        "true": "Oui"
      },
      "long": "Y a-t-il un écoulement purulent au niveau de la cicatrice&nbsp;?",
      "short": "Écoulement sur zone opératoire"
    },
    "woundInflammation": {
      "answers": {
        "false": "Non",
        "true": "Oui"
      },
      "long": "La cicatrice est elle inflammatoire&nbsp;? (rougeur, douleur, chaleur, œdème)&nbsp;?",
      "short": "Inflammation de la cicatrice"
    }
  },
  "dashboard": {
    "medical-synthesis": {
      "allergies-default-message": "Aucune allergie renseignée.",
      "medical-history-default-message": "Le composant spécifique n'a pas encore été développé.",
      "pathologies-default-message": "Aucune pathologie renseignée."
    },
    "medicines-reconciliation": {
      "section-default-message": "Non définies."
    },
    "patient-not-enrolled": "L'inclusion de ce patient n'est pas terminée."
  },
  "device": {
    "blood-pressure-monitor": "tensiomètre",
    "connected-blood-pressure-monitor": "un tensiomètre connecté",
    "connected-scales": "une balance connectée",
    "scales": "balance"
  },
  "dmp-bulk-download-default-row": {
    "biological-act-refunded-journal-event": "biologie",
    "drugs-and-devices-refunded-journal-event": "médicament",
    "hospitalisation-refunded-journal-event": "hospitalisation",
    "medical-act-refunded-journal-event": "consultation",
    "medical-imaging-prescribed-journal-event": "imagerie"
  },
  "evas": {
    "anxiety": "Anxiété",
    "energy": "Énergie",
    "irritability": "Irritabilité",
    "mood": "Humeur",
    "sleepDuration": "Sommeil"
  },
  "family": {
    "aunt": "Tante",
    "brother": "Frère",
    "father": "Père",
    "female-cousin": "Cousine",
    "grandfather": "Grand-père",
    "grandmother": "Grand-mère",
    "male-cousin": "Cousin",
    "mother": "Mère",
    "sister": "Soeur",
    "uncle": "Oncle"
  },
  "filters": {
    "disenrolled": "Désinscrits",
    "enrolled": "Inclus",
    "not-enrolled": "À inclure"
  },
  "follow-up-reason": {
    "all": "Toutes",
    "cardio-heart-failure": "Insuffisance cardiaque",
    "cardio-transplant": "Greffe coeur",
    "diabeto-dt2": "Diabète de type 2",
    "digest-crohn": "Maladie de Crohn",
    "digest-rch": "RCH",
    "disenrolled": "Désinscrit",
    "generic-general": "Suivi général",
    "hepato-transplant": "Greffe foie",
    "mental-bipolar": "Troubles bipolaires",
    "mental-depression": "Dépression",
    "nephro-donor": "Donneur",
    "nephro-generic": "Non précisé",
    "nephro-mrc": "MRC",
    "nephro-mrc-pro-irc": "MRC PRO IRC",
    "nephro-transplant": "Greffe rein",
    "not-enrolled": "À inclure",
    "onco-brain-cancer": "Cancer du cerveau ou cancer cérébral",
    "onco-breast-cancer": "Cancer du sein métastatique",
    "onco-breast-cancer-tnm0": "Cancer du sein non métastatique",
    "onco-cervix-cancer": "Cancer du col de l'utérus",
    "onco-colon-cancer": "Cancer du côlon",
    "onco-hemato-cancer": "Cancer hématologique",
    "onco-kidney-cancer": "Cancer du rein",
    "onco-liver-cancer": "Cancer du foie",
    "onco-lung-cancer": "Cancer du poumon",
    "onco-lymphoma-cancer": "Cancer hématologique : Lymphome",
    "onco-myeloma-cancer": "Cancer hématologique : Myélome",
    "onco-ovarian-cancer": "Cancer de l'ovaire",
    "onco-pancreatic-cancer": "Cancer du pancréas",
    "onco-prostate-cancer": "Cancer de la prostate",
    "onco-skin-cancer": "Cancer de la peau",
    "onco-stomach-cancer": "Cancer de l'estomac",
    "onco-testicular-cancer": "Cancer des testicules",
    "other": "-",
    "pneumo-transplant": "Greffe poumon",
    "rhumato-pr": "Polyarthrite rhumatoïde"
  },
  "frequency": {
    "1-day": "tous les jours",
    "1-month": "tous les mois",
    "1-week": "toutes les semaines",
    "1-year": "tous les ans",
    "2-day": "tous les deux jours",
    "2-month": "tous les deux mois",
    "2-week": "toutes les deux semaines",
    "2-year": "tous les deux ans",
    "3-day": "deux fois par semaine",
    "3-month": "tous les trois mois",
    "3-year": "tous les trois ans",
    "4-month": "tous les quatre mois",
    "5-month": "tous les cinq mois",
    "5-year": "tous les cinq ans",
    "6-month": "tous les six mois",
    "never": "jamais"
  },
  "fur": {
    "cancer-medical-history": {
      "cancerType": "{reason, select,\n  oncoLymphomaCancer {Lymphome}\n  oncoMyelomaCancer {Myéliome}\n  other {Inconnu}\n}\n",
      "computedTnm": "{key, select,\n  other {{key}}\n}\n",
      "diseaseStage": "{key, select,\n  premature {Précoce}\n  intermediate {Intermédiaire}\n  late {Tardif}\n  other {{key}}\n}\n",
      "donorType": "{key, select,\n  sibling {Donneur frère - HLA identique}\n  other {Autre donneur}\n}\n",
      "her2": "{key, select,\n  positive {positif}\n  negative {négatif}\n  other {{key}}\n}\n",
      "hormoneReceptors": "{key, select,\n  low {+}\n  medium {++}\n  high {+++}\n  other {{key}}\n}\n",
      "keys": "{key, select,\n  side {Côté}\n  computedTnm {TNM}\n  hormoneReceptors {Récepteurs hormonaux}\n  her2 {HER2}\n  other {{key}}\n}\n",
      "marital-status": {
        "couple": "Marié(e) / Concubin(e) / Pacsé(e)",
        "separated": "Séparé(e) / Divorcé(e)",
        "single": "Célibataire",
        "widowed": "Veuf(ve)"
      },
      "mutations": {
        "alk": "ALK",
        "braf": "BRAF",
        "brca1": "BRCA1",
        "brca2": "BRCA2",
        "egfr": "EGFR",
        "her2": "HER2",
        "kras": "KRAS",
        "met": "MET",
        "ros1": "ROS1",
        "stk11": "STK11"
      },
      "non-small-cell-cancer-type": {
        "adenocarcinoma": "Adénocarcinome",
        "large-cell-carcinoma": "Carcinome à grandes cellules",
        "squamous-cell-carcinoma": "Carcinome épidermoide"
      },
      "not-specified": "non renseigné",
      "pancreatic-mutations": {
        "atm": "ATM",
        "brca1": "BRCA1",
        "brca2": "BRCA2",
        "fanc-c": "FANC-C",
        "kras": "KRAS",
        "lkb1/stk11": "LKB1/STK11",
        "mlh1": "MLH1",
        "msh2": "MSH2",
        "msh6": "MSH6",
        "p16/cdkn2a": "P16/CDKN2A",
        "palb2": "PALB2",
        "pms2": "PMS2",
        "prss1": "PRSS1"
      },
      "prostate-mutations": {
        "atm": "ATM",
        "brca1": "BRCA1",
        "brca2": "BRCA2",
        "cdk12": "CDK12",
        "chek2": "CHEK2",
        "hoxb13": "HOXB13"
      },
      "side": "{key, select,\n  left {gauche}\n  right {droit}\n  bilateral {bilatéral}\n  other {{key}}\n}\n",
      "transplantDelay": "{key, select,\n  lt12Months {< 12 mois}\n  gte12Months {≥ 12 mois}\n  other {{key}}\n}\n"
    },
    "hemodialysis-type": {
      "at-home": "À domicile",
      "in-self-dialysis-unit": "En unité d'autodialyse",
      "in-udm": "En UDM"
    },
    "mental-main-diag": {
      "bipolarDisorderType1": "Trouble bipolaire type 1",
      "bipolarDisorderType2": "Trouble bipolaire type 2",
      "cyclothimicDisorder": "Trouble cyclothymique",
      "lightDepression": "Dépression légère",
      "mediumDepression": "Dépression modérée",
      "other": "Diagnostic inconnu",
      "persistingDepression": "Dépression résistante"
    },
    "mrc-stage": {
      "hemodialysis": "Hémodialyse",
      "peritoneal-dialysis": "Dialyse péritonéale à domicile",
      "stage-1": "Stade I",
      "stage-2": "Stade II",
      "stage-3": "Stade III",
      "stage-3-a": "Stade III A",
      "stage-3-b": "Stade III B",
      "stage-4": "Stade IV",
      "stage-5": "Stade V",
      "stage-undefined": "Stade non-défini"
    },
    "other-cancer-type": {
      "bladder": "Vessie",
      "colon": "Colon",
      "lung": "Poumon",
      "ovarian": "Ovaire"
    }
  },
  "hormonotherapy-molecule": {
    "abiraterone": "Abiraterone 500 mg",
    "apalutamide": "Apalutamide",
    "bicalutamide": "Bicalutamide",
    "buserelin": "Buserelin",
    "darolutamide": "Darolutamide",
    "degarelix": "Degarelix",
    "enzalutamide": "Enzalutamide",
    "flutamide": "Flutamide",
    "goserelin-10-8-mg": "Goserelin 10,8 mg",
    "goserelin-3-6-mg": "Goserelin 3,6 mg",
    "leuproréline": "Leuproréline",
    "triptorelin": "Triptorelin"
  },
  "hormonotherapy-type": {
    "anti-aromatase": "Anti-aromatase",
    "femara": "Femara",
    "sequential": "Séquentielle",
    "tamoxifen": "Tamoxifène"
  },
  "identity-access-logs": {
    "acceptedTermsOfUseVersion": "version des CGU acceptée",
    "address": "adresse",
    "birthFirstName": "prénom(s) de naissance",
    "birthGiven": "prénom(s) de naissance",
    "birthMunicipalityCode": "code lieu de naissance",
    "birthName": "nom de naissance",
    "birthPlace": "code lieu de naissance",
    "birthday": "date de naissance",
    "birthrank": "rang de naissance",
    "city": "ville",
    "contactPreferences": "préférences de contact",
    "cristalNumber": "numéro CRISTAL",
    "email": "e-mail",
    "fipNumber": "numéro FIP",
    "firstBirthFirstName": "1er prénom de naissance",
    "firstName": "prénom utilisé",
    "fullInsValue": "matricule INS",
    "gender": "sexe",
    "given": "prénom utilisé",
    "healthCentreId": "id de centre",
    "insIdentityDocument": "document pour validation de l'identité",
    "insOid": "OID",
    "insStatus": "statut",
    "insuredSocialSecurityNumber": "numéro d'assuré social",
    "ippNumber": "numéro IPP",
    "lastName": "nom utilisé",
    "moreAddressInformation": "complément d'adresse",
    "passwordChangedAt": "mot de passe changé le",
    "phone": "numéro de téléphone",
    "postcode": "code postal",
    "resetPasswordSentAt": "reset du mot de passe envoyé à",
    "sex": "sexe",
    "socialSecurityNumber": "numéro de sécurité sociale",
    "twoFactorAuthenticationEnabled": "authentification à double facteur",
    "twoFactorCodeCreatedAt": "code 2 facteurs créé le",
    "withingsUserId": "ID utilisateur Withings"
  },
  "infections": {
    "cutaneous": "cutanée",
    "dental": "dentaire",
    "ent": "ORL",
    "genital": "génitale",
    "other": "autre",
    "pulmonary": "pulmonaire",
    "urinary": "urinaire"
  },
  "ins": {
    "type": {
      "1.2.250.1.213.1.4.10": "TEST",
      "1.2.250.1.213.1.4.11": "DEMO",
      "1.2.250.1.213.1.4.8": "NIR",
      "1.2.250.1.213.1.4.9": "NIA",
      "unknown": "NIR ou NIA"
    }
  },
  "ipp-search-patient-form-errors": {
    "aph-code-missing": "Aucun code APH n'est associé à votre compte. Merci de vous rapprocher de notre équipe support en envoyant un mail à support@semeia.fr.",
    "forbidden": "Vous n'êtes pas autorisé à effectuer cette action.",
    "missing-health-centre-uuid": "Le UUID du centre de santé est manquant.",
    "missing-ipp-number": "Le numéro IPP est manquant.",
    "not-found": "Aucun patient trouvé avec le numéro IPP et le centre de santé spécifiés.",
    "unauthorized": "Merci de bien vouloir vous reconnecter."
  },
  "journal-events": {
    "alert-processed-journal-event": "Alerte traitée",
    "alert-triggered-journal-event": "{type, select, biological {biologique} clinical {clinique} journey {parcours} other {n/a} }",
    "back-to-work-journal-event": "Reprise du travail",
    "bio-exam-prescribed-journal-event": "Prescription d'examens biologiques",
    "bio-exam-results-received-journal-event": "Résultats de biologie reçus",
    "biological-act-refunded-journal-event": "Remboursement d'actes de biologie",
    "connected-device-acquired-journal-event": "Ajout d'un tensiomètre connecté",
    "consultation-planned-journal-event": "Rendez-vous",
    "consultation-report-written-journal-event": "Rapport de consultation",
    "diabetowise-discharge-completed-journal-event": "Fiche de sortie d'étude clinique",
    "dmp-document-retrieved-journal-event": "Document du DMP récupéré",
    "dn4-survey-taken-journal-event": "Réponse au questionnaire de douleur DN4",
    "drugs-and-devices-refunded-journal-event": "Remboursement de mécicaments et de fournitures",
    "equipment-ablation-journal-event": "Ablation de l'équipement",
    "equipment-installation-journal-event": "Installation de l'équipement",
    "equipment-settings-journal-event": "Réglages de l'équipement",
    "eva-survey-taken-journal-event": "Réponse à l'échelle de douleur EVA",
    "file-uploaded-journal-event": "Fichier téléversé",
    "generic-prescription-uploaded-journal-event": "Prescription générique reçue",
    "hospitalisation-refunded-journal-event": "Remboursement d'hospitalisation",
    "medical-act-refunded-journal-event": "Remboursement d'acte médical",
    "medical-event-journal-event": "Événement médical déclaré",
    "medical-imaging-prescribed-journal-event": "Prescription d'imagerie / d'examen médical",
    "medical-imaging-refunded-journal-event": "Remboursement d'imagerie médicale",
    "medication-prescribed-journal-event": "Prescription de médicaments",
    "online-consultation-report-written-journal-event": "Rapport de télé-consultation",
    "other": "Évenement inconnu",
    "pain-consultation-journal-event": "Consultation douleur",
    "painkiller-taken-journal-event": "Prise d'antalgique",
    "paramedical-care-prescribed-journal-event": "Prescription de soins médicaux",
    "patient-disenrolled-journal-event": "Désincription du programme",
    "patient-enrolled-journal-event": "Inclusion du patient",
    "physical-activity-resumed-journal-event": "Reprise d'une activité physique",
    "sf12-survey-taken-journal-event": "Réponse au questionnaire de bien-être SF12",
    "survey-completed-journal-event": "Réponses aux questionnaires envoyées",
    "survey-requested-journal-event": "Questionnaire envoyé au patient",
    "task-planned-journal-event": "Tâche plannifiée",
    "task-processed-journal-event": "Tâche traîtée",
    "therapeutic-assistance-session-completed-journal-event": "Session d'accompagnement thérapeutique complétée",
    "tls-prescribed-journal-event": "Prescription de télésurveillance",
    "treatment-prescription-changed-journal-event": "Traitement modifié"
  },
  "lifestyle": {
    "coaching": "{key, select,\n  sleep {Sommeil}\n  physicalActivity {Activité physique}\n  food {Alimentation}\n  drugs {Tabac, alcool, comportement à risque}\n  stress {Bien-être, gestion du stress}\n  other {Autre}\n}\n",
    "education-level": {
      "bac": "Baccalauréat / DAU / Diplôme équivalent",
      "bep": "CAP / BEP / Diplôme équivalent",
      "brevet": "Equivalent Brevet",
      "bts": "BTS / DUT / DEUG / Ecole de formations sanitaires ou sociales / Diplôme équivalent (bac +2)",
      "doctora": "Doctorat / HDR / Diplôme équivalent (bac +8)",
      "licence": "Licence / Maitrise/ Diplôme équivalent (bac+ 3/+4)",
      "master": "Master / DEA / DESS/ Diplôme d'ingénieur (bac +5)",
      "none": "Pas de diplôme / Certificat d'études primaires"
    },
    "housing": {
      "anotherFamilyMember": "Chez un autre membre de la famille",
      "childrenHome": "Chez ses enfants",
      "community": "En collectivité",
      "houseShare": "En colocation",
      "ownFamilyHome": "Dans son propre foyer familial",
      "parentsPlace": "Chez ses parents",
      "single": "Seul"
    },
    "job": "{key, select,\n  jobCoach {coach de travail}\n  socialAssistant {assistante sociale}\n  other {{key}}\n}\n",
    "main-income-origin": {
      "aah": "AAH",
      "apl": "APL",
      "invalidityBenefit": "Pension d'invalidité",
      "rmi": "RMI / RSA",
      "salary": "Salaire",
      "unemploymentBenefit": "Allocations chômage"
    },
    "marital-status": {
      "couple": "Marié(e) / Concubin(e) / Pacsé(e)",
      "separated": "Séparé(e) / Divorcé(e)",
      "single": "Célibataire",
      "widowed": "Veuf(ve)"
    },
    "professional-activity": {
      "activeFullTime": "Actif à temps plein",
      "activePartTime": "Actif à temps partiel",
      "retired": "Retraité",
      "student": "Etudiant",
      "unemployed": "Sans emploi",
      "volonteer": "Bénévolat"
    }
  },
  "mammography-exam": {
    "date-label": {
      "mammography": "Date de la mammographie",
      "mri": "Date de l'IRM"
    },
    "type": {
      "mammography": "Mammographie",
      "mri": "IRM"
    }
  },
  "medic": {
    "role": {
      "doctor": "médecin",
      "medical_secretary": "secrétaire médicale",
      "nurse": "infirmier.e (IDE)",
      "nurse_lead": "infirmier.e (IPA)",
      "research_assistant": "attaché(e) de recherche clinique (ARC)",
      "retail_pharmacist": "pharmacien d'officine"
    }
  },
  "medical-history-changed-journal-event": {
    "diagnostic-type": {
      "diverticulitis": "Recto sigmoïdite",
      "pancolitis": "Pancolite",
      "proctitis": "Rectite"
    },
    "disease-activity": {
      "inactive": "Inactive",
      "moderate": "Modérée",
      "severe": "Sévère",
      "weak": "Faible"
    }
  },
  "mici-form": {
    "abdominalPain": {
      "answers": {
        "false": "Non",
        "true": "Oui"
      },
      "long": "Avez-vous ressenti des douleurs dans l'abdomen&nbsp;?",
      "short": "Douleurs dans l'abdomen"
    },
    "abdominalPainIntensity": {
      "answers": {
        "0": "Aucun",
        "1": "Légère",
        "2": "Modérée",
        "3": "Sévère"
      },
      "long": "Quelle était l'intensité de vos pires douleurs dans l'abdomen&nbsp;?",
      "short": "Intensité de ces pires douleurs"
    },
    "analIncontinence": {
      "answers": {
        "false": "Non",
        "true": "Oui"
      },
      "long": "Avez-vous eu des épisodes d'incontinence anale&nbsp;?",
      "short": "Incontinence anale"
    },
    "analIncontinenceFrequency": {
      "answers": {
        "0": "Rarement",
        "1": "Parfois",
        "2": "Souvent",
        "3": "Toujours"
      },
      "long": "À quelle fréquence avez-vous eu des épisodes d'incontinence anale&nbsp;?",
      "short": "Fréquence d'incontinence"
    },
    "anusSymptoms": {
      "answers": {
        "false": "Non",
        "true": "Oui"
      },
      "long": "Avez-vous eu des symptômes au niveau de l'anus&nbsp;?",
      "short": "Symptômes à l'anus"
    },
    "anusSymptomsFrequency": {
      "answers": {
        "0": "Jamais",
        "1": "Occasionnellement",
        "2": "Une à quelques fois par semaine",
        "3": "Tous les jours",
        "4": "Plusieurs fois par jour"
      },
      "long": "À quelle fréquence avez-vous eu des symptômes au niveau de l'anus&nbsp;?",
      "short": "Fréquence de ces symptômes"
    },
    "articularPain": {
      "answers": {
        "false": "Non",
        "true": "Oui"
      },
      "long": "Avez-vous eu des douleurs articulaires&nbsp;?",
      "short": "Douleurs articulaires"
    },
    "articularPainIbd": {
      "answers": "{ value }/10",
      "long": "Mes articulations me font souffrir.",
      "short": "Douleurs articulaires"
    },
    "articularPainSeverity": {
      "answers": {
        "1": "Légère",
        "2": "Modérée",
        "3": "Sévère",
        "4": "Très sévère"
      },
      "long": "Quelle était la sévérité de vos pires douleurs articulaires&nbsp;?",
      "short": "Sévérité de ces douleurs"
    },
    "averageStoolsNumber": {
      "answers": "{ value }",
      "long": "Combien de selles en moyenne avez-vous eues en 24h&nbsp;?",
      "short": "Moyenne de selles /24h"
    },
    "bloodInStool": {
      "answers": {
        "false": "Non",
        "true": "Oui"
      },
      "long": "Avez-vous eu du sang dans les selles&nbsp;?",
      "short": "Sang dans selles"
    },
    "bloodInStoolFrequency": {
      "answers": {
        "1": "Sang visible moins d'une évacuation sur deux",
        "2": "Sang visible dans les selles une évacuation sur deux ou plus",
        "3": "Sang s'écoulant à toutes les évacuations"
      },
      "long": "À quelle fréquence avez-vous remarqué du sang dans les selles&nbsp;?",
      "short": "Fréquence du sang"
    },
    "bodyDissatisfaction": {
      "answers": "{ value }/10",
      "long": "Je n'aime pas mon corps ou certaines parties de mon corps.",
      "short": "Image de soi"
    },
    "eyeSymptoms": {
      "answers": {
        "false": "Non",
        "true": "Oui"
      },
      "long": "Avez-vous eu des symptômes au niveau des yeux&nbsp;?",
      "short": "Symptômes aux yeux"
    },
    "eyeSymptomsPainful": {
      "answers": {
        "false": "Non",
        "true": "Oui"
      },
      "long": "Avez-vous eu les yeux douloureux&nbsp;?",
      "short": "Yeux douloureux"
    },
    "eyeSymptomsRedEye": {
      "answers": {
        "false": "Non",
        "true": "Oui"
      },
      "long": "Avez-vous eu les yeux rouges&nbsp;?",
      "short": "Yeux rouges"
    },
    "eyeSymptomsSight": {
      "answers": {
        "false": "Non",
        "true": "Oui"
      },
      "long": "Avez-vous eu une baisse de la vision&nbsp;?",
      "short": "Baisse vision"
    },
    "fever": {
      "answers": {
        "false": "Non",
        "true": "Oui"
      },
      "long": "Avez-vous eu de la fièvre&nbsp;?",
      "short": "Fièvre"
    },
    "feverLevel": {
      "answers": "{ value } °C",
      "long": "Quelle est votre température (en °C)&nbsp;?",
      "short": "Température corporelle"
    },
    "fistulasEmbarrassment": {
      "answers": {
        "0": "Jamais",
        "1": "Occasionnellement",
        "2": "Une à quelques fois par semaine",
        "3": "Tous les jours",
        "4": "Plusieurs fois par jour"
      },
      "long": "Ressentez-vous une gêne en continu autour de l'anus à cause de votre (vos) fistule(s)&nbsp;?",
      "short": "Gêne autour de l'anus liée à la fistule"
    },
    "fistulasFlow": {
      "answers": {
        "0": "Jamais",
        "1": "Occasionnellement",
        "2": "Une à quelques fois par semaine",
        "3": "Tous les jours",
        "4": "Plusieurs fois par jour"
      },
      "long": "Avez-vous des écoulements en rapport avec votre (vos) fistule(s)&nbsp;?",
      "short": "Écoulements lié à la fistule"
    },
    "fistulasMovement": {
      "answers": {
        "0": "Jamais",
        "1": "Occasionnellement",
        "2": "Une à quelques fois par semaine",
        "3": "Tous les jours",
        "4": "Plusieurs fois par jour"
      },
      "long": "Est-ce que votre (vos) fistule(s) vous empêche(nt) de vous asseoir, vous tenir debout ou marcher&nbsp;?",
      "short": "Difficultés de mouvement liée à la fistule"
    },
    "fistulasPain": {
      "answers": {
        "0": "Jamais",
        "1": "Occasionnellement",
        "2": "Une à quelques fois par semaine",
        "3": "Tous les jours",
        "4": "Plusieurs fois par jour"
      },
      "long": "Avez-vous une douleur vive et intense autour de l'anus à cause de votre (vos) fistule(s)&nbsp;?",
      "short": "Douleurs vives et intenses liées à la fistule"
    },
    "fistulasPainSkin": {
      "answers": {
        "0": "Jamais",
        "1": "Occasionnellement",
        "2": "Une à quelques fois par semaine",
        "3": "Tous les jours",
        "4": "Plusieurs fois par jour"
      },
      "long": "Est-ce que votre peau est douloureuse et irritée autour de votre (vos) fistule(s) à cause des écoulements&nbsp;?",
      "short": "Peau douloureuse et irritée liée à la fistule"
    },
    "hasFistulas": {
      "answers": {
        "false": "Non",
        "true": "Oui"
      },
      "long": "Souffrez-vous d'une ou plusieurs fistule(s)&nbsp;?",
      "short": "Fistule(s)"
    },
    "immediateStool": {
      "answers": {
        "false": "Non",
        "true": "Oui"
      },
      "long": "Avez-vous ressenti le besoin immédiat d'aller à la selle&nbsp;?",
      "short": "Besoin immédiat d'aller à la selle"
    },
    "immediateStoolUrgency": {
      "answers": "{ value }/10",
      "long": "Urgence (0 = Aucune urgence, 10 = Urgence maximale imaginable)",
      "short": "Echelle de l'urgence"
    },
    "lackOfEnergy": {
      "answers": "{ value }/10",
      "long": "Je ne me suis jamais senti(e) véritablement reposé(e), j'ai manqué d'énergie, je me suis senti(e) fatigué(e).",
      "short": "Energie"
    },
    "lowMood": {
      "answers": "{ value }/10",
      "long": "Je me suis senti(e) triste, mon moral a été bas, ou je me suis senti(e) déprimé(e) et/ou inquit(ète) et/ou anxieux(euse).",
      "short": "Niveau de stress, anxiété"
    },
    "mouthUlcers": {
      "answers": {
        "false": "Non",
        "true": "Oui"
      },
      "long": "Avez-vous eu des aphtes buccaux&nbsp;?",
      "short": "Aphtes buccaux"
    },
    "repeatedVomiting": {
      "answers": {
        "false": "Non",
        "true": "Oui"
      },
      "long": "Avez-vous eu des épisodes de vomissements répétés durant les dernières 48h&nbsp;?",
      "short": "Vomissements répétés dans les 48h"
    },
    "sexualDifficulties": {
      "answers": "{ value }/10",
      "long": "J'ai eu des difficultés d'ordre psychologique et/ou physique dans ma sexualité.",
      "short": "Vie intime"
    },
    "skinSymptoms": {
      "answers": {
        "false": "Non",
        "true": "Oui"
      },
      "long": "Avez-vous eu des symptômes au niveau de la peau&nbsp;?",
      "short": "Symptômes sur la peau"
    },
    "sleepDifficulties": {
      "answers": "{ value }/10",
      "long": "J'ai eu des difficultés de sommeil, par exemple des problèmes d'endormissement, des réveils nocturnes fréquents ou des réveils très matinaux sans possibilité de rendormissement.",
      "short": "Sommeil"
    },
    "socialDifficulties": {
      "answers": "{ value }/10",
      "long": "J'ai eu des difficultés dans ma relation aux autres et/ou des difficultés d'intégration.",
      "short": "Vie sociale"
    },
    "stomachPain": {
      "answers": "{ value }/10",
      "long": "J'ai eu des douleurs au ventre et/ou à l'estomac.",
      "short": "Douleurs abdominales"
    },
    "stoolsNumber": {
      "answers": "{ value }",
      "long": "Combien de selles liquides ou très molles en moyenne par jour avez-vous eues&nbsp;?",
      "short": "Nombre de selles"
    },
    "transitBlockage": {
      "answers": {
        "false": "Non",
        "true": "Oui"
      },
      "long": "Avez-vous eu un blocage du transit (absence de selles et de gaz) pendant les dernières 24h associé à de fortes douleurs abdominales&nbsp;?",
      "short": "Blocage du transit dans les 24h"
    },
    "urgentStoolsMovements": {
      "answers": "{ value }/10",
      "long": "J'ai eu des selles urgentes que j'ai eu du mal à gérer ; trouver des toilettes à temps a été un problème et j'ai parfois eu des difficultés d'essuyage/nettoyage.",
      "short": "Régulation de la défécation"
    },
    "weight": {
      "answers": "{ value } kg",
      "long": "Quelle est votre poids (en kg)&nbsp;?",
      "short": "Poids actuel"
    },
    "wellBeing": {
      "answers": {
        "0": "Très bon",
        "1": "Bon",
        "2": "Pas très bon",
        "3": "Mauvais",
        "4": "Très mauvais"
      },
      "long": "Comment estimez-vous votre bien-être général&nbsp;?",
      "short": "Bien-être général"
    },
    "workDifficulties": {
      "answers": "{ value }/10",
      "long": "J'ai eu des difficultés dans mes activités professionnelles ou dans mes études ou dans la réalisation des tâches quotidiennes.",
      "short": "Activités professionnelles et scolaires"
    }
  },
  "monitoringPointReport": {
    "ppsSections": {
      "actions": {
        "addictologist-consultation": "Consultation addictologue",
        "bio-exams-done": "Examens biologiques réalisés",
        "blood-pressure-measured": "Mesures de la tension",
        "cardiologist-consultation": "Consultation cardiologue",
        "crisis-plan-follow-up": "Définition du plan de crise",
        "diabetologist-consultation": "Consultation diabétologue",
        "doctor-consultation": "Consultation médecin généraliste",
        "drugs": "Tabac, alcool, comportements à risque",
        "food": "Alimentation",
        "group-psychotherapy": "Psychothérapie de groupe",
        "gynecologist-consultation": "Consultation gynécologue",
        "happy-neuron-digital-care": "Prise en charge numérique HappyNeuron",
        "jobCoach": "Coach de travail",
        "medicines-reconciliation": "Conciliation pharmaceutique",
        "nephrologist-consultation": "Consultation néphrologue",
        "neurologist-consultation": "Consultation neurologue",
        "physicalActivity": "Activité physique",
        "psychiatrist-consultation": "Consultation psychiatre",
        "psychologist-consultation": "Consultation psychologue",
        "simple-digital-care": "Prise en charge numérique SIMPLe",
        "sleep": "Sommeil",
        "socialAssistant": "Assistante sociale",
        "stress": "Bien-être, gestion du stress",
        "therapeutic-education": "Éducation thérapeutique",
        "treatment-taken": "Traitement pris",
        "weight-measured": "Mesure du poids"
      },
      "name": {
        "life-hygiene": "Hygiène de vie",
        "observance": "Observance et bon usage des traitements",
        "physical-health": "Santé physique",
        "psychiatric-health": "Psychiatrie, addictions et psychothérapie",
        "socio-professional": "Socio-professionnel"
      }
    }
  },
  "nephropaties": {
    "name": "{key, select,\n  nephropathy_undefined {Indéterminée}\n  nephropathy_diabetic {Diabétique}\n  nephroangiosclerose {Néphroangiosclérose (HTA)}\n  berger_disease {Maladie de Berger}\n  hyalinosis {Hyalinose segmentaire et focale}\n  glomerulonephritis {Glomérulonéphite extra-membraneuse}\n  polycystic_kidney_disease {Polykystose rénale}\n  uropathies {Uropathies}\n  lupus {Lupus}\n  vasculitis {Vascularite}\n  pyelonephritis {Pyélonéphrite}\n  other {{key}}\n}\n"
  },
  "ok-chimio-status": {
    "paused": "En pause",
    "validated": "Validé"
  },
  "operator": {
    "equal-to": "=",
    "greater-than": ">",
    "lower-than": "<"
  },
  "other-events": {
    "abdominal-ultrasound": "Echographie abdo",
    "addictologist": "Addictologue",
    "anaesthetist-consultation": "Consultation anesthésiste",
    "announcement-consultation": "Consultation d'annonce",
    "bone-scan": "Scintigraphie osseuse",
    "computed-tomography": "TDM Tomodensitométrie",
    "dentist": "Dentiste",
    "echocardiography": "Echographie du cœur",
    "mammography": "Mammographie",
    "mri": "IRM",
    "preoperative-nurse-appointment": "RDV IDE pré-opératoire",
    "psychologist": "Psychologue",
    "respiratory-cine": "Ciné respiratoire",
    "scanner": "Scanner",
    "sentinel-node-lymphoscinthigraphy": "Lymphoscinthigraphie ganglion sentinelle",
    "smoking-cessation": "Sevrage tabagique",
    "social-worker": "Assistante sociale",
    "tracking-scanner": "Scanner de repérage",
    "ultrasound-spotting": "Repérage sous échographie"
  },
  "other-protocol": {
    "default-chemotherapy": {
      "lastTherapy": "Dernière  cure",
      "therapyFive": "Cure 5",
      "therapyFour": "Cure 4",
      "therapyOne": "Cure 1",
      "therapyThree": "Cure 3",
      "therapyTwo": "Cure 2"
    },
    "default-hormonotherapy": {
      "endDate": "Date de fin",
      "startDate": "Date de début"
    },
    "default-immunotherapy": {
      "endDate": "Date de fin",
      "startDate": "Date de début"
    },
    "default-other-follow-up-events": {
      "cureDate": "Date de l'événement"
    },
    "default-radiotherapy": {
      "endDate": "Date de fin",
      "startDate": "Date de début"
    },
    "default-surgery": {
      "cureDate": "Date de la chirurgie"
    },
    "default-targeted-therapy": {
      "endDate": "Date de fin",
      "startDate": "Date de début"
    }
  },
  "passive-data": {
    "dashboard": {
      "activations": "Activation smartphone",
      "steps": "Nombre de pas",
      "visits": "Lieux visités"
    },
    "graph": {
      "by-day": {
        "title": "{kind, select,\n  steps {Nombre de pas par jour}\n  visits {Nombre de lieux visités par jour}\n  activations {Nombre d'utilisation du téléphone par jour}\n  other {}\n}\n"
      }
    }
  },
  "pathology": {
    "cytomegalovirus-status": {
      "d_minus_r_minus": "D- / R-",
      "d_minus_r_plus": "D- / R+",
      "d_plus_r_minus": "D+ / R-",
      "d_plus_r_plus": "D+ / R+"
    },
    "heart-failure-type": {
      "heart-failure-with-preserved-ejection-fraction": "Insuffisance cardiaque à fraction d'éjection préservée (ICFEP)",
      "systolic-heart-failure": "Insuffisance cardiaque systolique (ICS)"
    },
    "transplanted-organ": {
      "bipulmonary": "Bipulmonaire (TBP)",
      "heart": "Coeur",
      "heart-kidney": "Coeur/Rein",
      "heart-kidney-liver": "Coeur/Rein/Foie",
      "heart-lung": "Coeur/Poumon",
      "heart-lung-kidney": "Coeur/Poumon/Rein",
      "kidney-heart-liver": "Foie/Coeur/Rein",
      "kidney-liver": "Foie/Rein",
      "liver": "Foie",
      "liver-kidney": "Foie/Rein",
      "liver-lung": "Foie/Poumon",
      "liver-lung-kidney": "Foie/Poumon/Rein",
      "lung-heart": "Poumon/Coeur",
      "lung-kidney": "Poumon/Rein",
      "monopulmonary": "Monopulmonaire (TMP)"
    },
    "underlying-disease": {
      "amyloidosis-aa": "Amylose AA",
      "amyloidosis-al": "Amylose AL",
      "amyloidosis-ttr": "Amylose TTR",
      "cardiomyopathy": "Myocardiopathie",
      "congenital-heart-defects": "Malformations cardiaques congénitales",
      "cystic_fibrosis": "Mucoviscidose",
      "drug-cardiotoxicity": "Cardiotoxicité médicamenteuse",
      "drug-induced-hepatitis": "Hépatites médicamenteuses",
      "fulminant-hepatitis": "Hépatite fulminante",
      "heart-rhythm-disorders": "Troubles du rythme cardiaque",
      "hepatic-cirrhosis": "Cirrhose hépatique",
      "hepatic-fibrosis": "Fibrose hépatique",
      "hereditary-amyloidosis": "Amylose héréditaire",
      "high-blood-pressure": "Hypertension artérielle",
      "hypertrophic-cardiomyopathy": "Cardiomyopathie Hypertrophique",
      "ischemic-heart-disease": "Cardiopathie ischémique",
      "myocardial-infarction": "Infarctus du myocarde",
      "non-ischemic-dilated-cardiomyopathy": "Cardiomyopathie dilatée non ischémique",
      "obstructive_diseases": "Maladies obstructives des voies aériennes",
      "other": "Autre",
      "pulmonary_fibrosis": "Fibrose pulmonaire d'origine toxique, médicamenteuse ou immunologique",
      "steatosis": "Stéatose",
      "valve-anomaly": "Anomalie des valves",
      "valvular-heart-disease": "Cardiopathie valvulaire",
      "viral-hepatitis": "Hépatites virales"
    }
  },
  "patient": {
    "birthrank": "rang de naissance",
    "born": "{gender, select,\n  male {Né}\n  female {Née}\n  other {Né}\n} le\n",
    "email": "e-mail",
    "gender": "{gender, select,\n  male {Homme}\n  female {Femme}\n  other {Inconnu}\n}\n",
    "insured-social-security-number": "numéro de sécurité sociale de l'assuré(e) (prescription / facturation)",
    "occupation": "{occupation, select,\n  active {Actif}\n  retired {Retraité}\n  unemployed {Sans emploi}\n  other {Autre}\n}\n",
    "phone": "numéro de téléphone",
    "social-security-number": "numéro de sécurité sociale",
    "title": "{gender, select,\n  male {M.}\n  female {Mme}\n  other {}\n}\n"
  },
  "patient-history": {
    "meta-dashboard-row": {
      "treatment-history-changed-journal-events": {
        "chemotherapies": "Chimiothérapie",
        "hormonotherapies": "Hormonothérapie",
        "immunotherapies": "Immunothérapie",
        "oncologies": "Consultation d'oncologie",
        "otherFollowUpEvents": "Autres événements de parcours",
        "radiotherapies": "Radiothérapie",
        "surgerySurgeries": "Chirurgie oncologique",
        "targetedTherapies": "Thérapie ciblée"
      }
    }
  },
  "patient-tabs": {
    "alert": "Actualités",
    "consult-chat": "Messagerie",
    "consult-timeline": "Timeline",
    "get-global-medical-synthesis": "Voir la synthèse médicale globale du patient",
    "planification": "Planification d'un événement",
    "start-online-consultation": "Téléconsultation",
    "upload-document": "Importer un document",
    "write-appointment-summary": "Rédiger un compte-rendu",
    "write-therapeutic-assistance": "Séance d'accompagnement thérapeutique"
  },
  "pr-type": {
    "seronegative": "Séronégative",
    "seropositive": "Séropositive"
  },
  "predictor": {
    "box": {
      "mental-bipolar": {
        "adherence-prediction-computed-journal-event": "Risque de non adhésion au traitement"
      },
      "nephro-transplant": {
        "adherence-prediction-computed-journal-event": "Risque de non observance médicamenteuse"
      },
      "onco-breast-cancer": {
        "adherence-prediction-computed-journal-event": "Risque de non adhésion au traitement"
      },
      "onco-breast-cancer-tnm0": {
        "adherence-prediction-computed-journal-event": "Risque de non adhésion au traitement"
      }
    },
    "error": {
      "hormonotherapy-start-date-too-late": "L'hormonothérapie a démarré il y a trop longtemps pour pouvoir effectuer une prédiction fiable.",
      "missing-parameter": "Certains paramètres indispensables à la prédiction sont manquants.",
      "no-hormonotherapy-treatment": "Aucune prise d'hormonothérapie renseignée.",
      "no-model-available": "Le type de prédiction demandé n'est pas accessible.",
      "other": "Erreur inconnue."
    },
    "feature-names": {
      "age": "âge",
      "log_anc_ald": "ancienneté de déclaration en ALD",
      "metastatique": "métastatique",
      "previous_chimio": "chimiothérapie précédente",
      "previous_radio": "radiothérapie précédente",
      "previous_surgery": "chirurgie précédente",
      "treatment_ANASTROZOLE": "suit un traitement à l'anastrozole",
      "treatment_EXEMESTANE": "suit un traitement à l'exemestane",
      "treatment_LETROZOLE": "suit un traitement au letrozole",
      "treatment_TAMOXIFENE": "suit un traitement au tamoxifène"
    },
    "risk": {
      "average-risk": "moyen",
      "high-risk": "élevé",
      "low-risk": "faible",
      "other": "inconnu"
    },
    "risk-type": {
      "hospitalisation": "hospitalisation",
      "observance": "non observance",
      "persistence": "non persistance",
      "toxicity": "toxicité"
    }
  },
  "prescriptions": {
    "dashboard": {
      "cd": "jour",
      "d": "jour",
      "eve": "jour",
      "mo": "mois",
      "morn": "jour",
      "wk": "semaine"
    },
    "doseQuantities": {
      "0.25": "1/4",
      "0.5": "1/2",
      "1": "1",
      "1.5": "1 + 1/2",
      "10": "10",
      "100": "100",
      "2": "2",
      "2.5": "2 + 1/2",
      "3": "3",
      "3.5": "3 + 1/2",
      "4": "4",
      "4.5": "4 + 1/2",
      "5": "5",
      "5.5": "5 + 1/2",
      "6": "6",
      "6.5": "6 + 1/2",
      "7": "7",
      "7.5": "7 + 1/2",
      "8": "8",
      "8.5": "8 + 1/2",
      "9": "9",
      "9.5": "9 + 1/2"
    },
    "examsFrequencies": {
      "1-month": "Tous les mois",
      "1-week": "Toutes les semaines",
      "1-year": "Tous les ans",
      "2-month": "Tous les deux mois",
      "2-week": "Toutes les deux semaines",
      "3-month": "Tous les trois mois",
      "3-week": "Toutes les trois semaines",
      "4-month": "Tous les quatre mois",
      "5-month": "Tous les cinq mois",
      "6-month": "Tous les six mois",
      "once": "Ne pas renouveler"
    },
    "monthPeriods": "{id, select,\n  0 {Examen ponctuel}\n  1 {Tous les mois}\n  2 {Tous les deux mois}\n  3 {Tous les trois mois}\n  4 {Tous les quatre mois}\n  other {Période inconnue}\n}\n",
    "prefixes": {
      "bio-exam-prescribed-journal-event": "ordo-biologie",
      "generic-prescription-uploaded-journal-event": "ordo-générique",
      "medical-imaging-prescribed-journal-event": "ordo-imagerie",
      "medication-prescribed-journal-event": "ordo-medicaments",
      "paramedical-care-prescribed-journal-event": "ordo-soins-médicaux",
      "tls-prescribed-journal-event": "ordo-tls"
    },
    "timings": {
      "0-0-": "autre",
      "1-1-a": "Tous les ans",
      "1-1-d": "par jour",
      "1-1-d-cd": "à midi",
      "1-1-d-eve": "le soir",
      "1-1-d-morn": "le matin",
      "1-1-mo": "tous les mois",
      "1-1-wk": "par semaine",
      "1-2-mo": "tous les deux mois",
      "1-4-mo": "tous les quatre mois",
      "2-1-d": "matin, et soir",
      "2-1-d-cd-eve": "midi, et soir",
      "2-1-d-cd-morn": "matin, et midi",
      "3-1-d": "matin, midi et soir",
      "3-1-wk": "trois fois par semaine",
      "4-1-d": "matin, midi, goûter et soir"
    },
    "validity-period": {
      "day": "jour",
      "days": "jours",
      "month": "mois",
      "months": "mois",
      "week": "semaine",
      "weeks": "semaines",
      "year": "an"
    }
  },
  "radiotherapy-type": {
    "curietherapy": "Curiéthérapie",
    "external-radiotherapy": "Radiothérapie externe",
    "metabolic-radiotherapy": "Radiothérapie métabolique"
  },
  "reimbursements": {
    "nature": "{nature, select,\n  AM {Actes médicaux et dentaires}\n  LB {Actes de biologie}\n  RD {Actes de radiologie}\n  IJ {Arrêts indemnisés}\n  OF {Pharmacie, fournitures}\n  CP {Hôpitaux, établissements}\n  TR {Transport}\n  other {Autre}\n}\n",
    "regime": "{code, select,\n   01 {Régime général}\n   02 {Régime agricole}\n   03 {Régime Social des Indépendants (RSI)}\n   04 {SNCF}\n   05 {RATP}\n   06 {Etablissement National des Invalides de la Marine (ENIM)}\n   07 {Mineurs et assimilés}\n   08 {Militaires de carrière}\n   09 {Personnel de la Banque de France}\n   10 {Clercs et employés de notaire}\n   12 {Chambre de Commerce et d'Industrie de Paris}\n   14 {Assemblée Nationale}\n   15 {Caisses Autonomes de Sécurité Sociale du Sénat}\n   16 {Port autonome de Bordeaux}\n   17 {Caisse des Français de l'étranger}\n   80 {Ministère des anciens combattants}\n   90 {Caisse d'Assurance Maladie des cultes}\n   91 {Mutuelle Générale de l'Education Nationale (MGEN)}\n   92 {Mutuelle Générale (MG)}\n   93 {Mutuelle Générale de la Police (MGP)}\n   94 {Fédération fonctionnaire (SLI)}\n   95 {Mutuelle Nationale des Hospitaliers (MNH)}\n   96 {Mutuelle de la Marine}\n   99 {Autres mutuelles}\n   other {Régime inconnu}\n}\n",
    "retrieving-modal-messages": {
      "error": {
        "details": {
          "cnam-api-cps-card-blocked": "Pour débloquer votre carte, suivez <a href=\"http://vegatv.fr/debloquer-sa-cps/\" target=\"_blank\">la procédure vidéo</a> si vous possédez l'application CPS-Gestion sur votre ordinateur. Sinon, contactez l’<b>ASIP-santé</b> / Tél. 0825 85 2000.",
          "cnam-api-cps-card-error": "Vérifiez que votre carte CPS est bien insérée dans le lecteur, puis réessayez.",
          "cnam-api-cps-card-wrong-code": "Le code doit être composé de 4 chiffres. Veuillez réessayer.",
          "cnam-api-cps-no-billing-number": "Il n'y a aucune information de facturation présente sur votre carte CPS. Veuillez envoyer un mail à support@semeia.io en nous indiquant le message d'erreur.",
          "cnam-api-cps-no-practice-locations": "Il n'y a aucune situation d'exercice présente sur votre carte CPS. Veuillez envoyer un mail à support@semeia.io en nous indiquant le message d'erreur.",
          "cnam-api-dmp-authorization-denied": "Vous n'avez pas accès au DMP de ce patient.",
          "cnam-api-dmp-no-reimbursement-document": "Il n'y a pas encore d'historique de remboursement disponible dans le DMP de ce patient. <br />Réessayez dans quelques jours.",
          "cnam-api-dmp-parsing-file-error": "Impossible d'extraire des données de remboursement, veuillez réessayer ultérieurement. Si l'erreur persiste, contactez-nous à l'adresse suivante : support@semeia.io.",
          "cnam-api-dmp-status-closed": "Le DMP de ce patient ne peut pas être consulté tant qu'il n'est pas réactivé.",
          "cnam-api-dmp-status-not-found": "Le patient n'a pas encore ouvert son DMP, et ne peut donc pas être consulté.",
          "cnam-api-dmpconnect-js-not-available": "Le connecteur DMPConnectJS est obligatoire pour accéder au DMP et nécessite une installation.",
          "cnam-api-error": "Erreur lors de la récupération",
          "cnam-api-ins-birthday-invalid-error": "La date de naissance retournée par le service INSi est invalide.",
          "cnam-api-ins-conflict-with-ssn-error": "NIR différent de celui renseigné dans la fiche patient. Veuillez vérifier que le patient est bien l’assuré.",
          "cnam-api-ins-error": "Erreur lors de la récupération de l'INS",
          "cnam-api-ins-identity-corrupted-error": "L'identité est corrompue. Les informations retournées sont invalides.",
          "cnam-api-ins-mandatory-info-missing-error": "Il manque des informations dans la fiche patient qui empêche l'appel au service INS.",
          "cnam-api-ins-multiple-identity-found-error": "Plusieurs identités ont été retournées par le service. Reessayez après avoir précisé les informations.",
          "cnam-api-ins-no-identity-found-error": "Aucune identité trouvée pour ce patient. Veuillez vérifier ses données.",
          "cnam-api-ins-no-sex-error": "Le sexe retourné par le service INSi est vide.",
          "cnam-api-ins-patient-invalid": "Certaines informations administratives sont nécessaires pour récupérer l'INS du patient.",
          "cnam-api-vitale-card-error": "Vérifiez que la carte vitale du patient est bien insérée dans le lecteur, puis réessayez.",
          "other": "Veuillez réessayer. Si l'erreur persiste, contactez nous à l'adresse suivante : support@semeia.io."
        },
        "header": {
          "cnam-api-cps-card-blocked": "Carte CPS bloquée",
          "cnam-api-cps-card-error": "Carte CPS non détectée",
          "cnam-api-cps-card-infos-missing": "Erreur lors de l'accès aux informations de la carte CPS",
          "cnam-api-cps-card-wrong-code": "Code d'accès incorrect",
          "cnam-api-cps-no-billing-number": "Informations de facturation manquantes",
          "cnam-api-dev-box-sante-not-available": "Connecteur DMP non détecté",
          "cnam-api-dmp-authorization-denied": "Accès au DMP refusé",
          "cnam-api-dmp-missing-patient-information": "Dossier patient incomplet",
          "cnam-api-dmp-no-reimbursement-document": "Aucun résultat",
          "cnam-api-dmp-parsing-file-error": "Le format des données de remboursement est invalide",
          "cnam-api-dmp-status-closed": "DMP fermé",
          "cnam-api-dmp-status-not-found": "DMP non trouvé",
          "cnam-api-dmpconnect-js-not-available": "Connecteur DMP non détecté",
          "cnam-api-ins-birthday-invalid-error": "Erreur sur les informations administratives",
          "cnam-api-ins-conflict-with-ssn-error": "Conflit sur le numéro de sécurité sociale",
          "cnam-api-ins-identity-corrupted-error": "Identité corrompue",
          "cnam-api-ins-mandatory-info-missing-error": "Informations manquantes",
          "cnam-api-ins-multiple-identity-found-error": "Plusieurs identités trouvées",
          "cnam-api-ins-no-identity-found-error": "Identité non trouvée",
          "cnam-api-ins-no-sex-error": "Erreur sur les informations administratives",
          "cnam-api-ins-patient-invalid": "Informations manquantes pour le patient",
          "cnam-api-vitale-card-error": "Carte vitale non détectée",
          "other": "Une  erreur est survenue"
        },
        "icon": {
          "cnam-api-cps-card-blocked": "lock",
          "cnam-api-cps-card-error": "id card",
          "cnam-api-cps-card-wrong-code": "key",
          "cnam-api-dmp-authorization-denied": "key",
          "cnam-api-dmp-missing-patient-information": "address card outline",
          "cnam-api-dmp-no-reimbursement-document": "file outline",
          "cnam-api-dmp-status-closed": "lock",
          "cnam-api-dmp-status-not-found": "question",
          "cnam-api-ins-identity-corrupted-error": "search",
          "cnam-api-ins-mandatory-info-missing-error": "search",
          "cnam-api-ins-multiple-identity-found-error": "search",
          "cnam-api-ins-no-identity-found-error": "search",
          "cnam-api-vitale-card-error": "id card",
          "other": "times"
        }
      },
      "loading": {
        "details": "{state, select,\n  LoadingCheckingCardsAndCpsCode {Lecture des cartes et vérification du code d'accès}\n  LoadingRetrievingData {Cette étape peut durer plusieurs dizaines de secondes. Veuillez patienter.}\n  other {}\n}\n",
        "header": "{state, select,\n  LoadingReadingCpsCard {Vérification en cours}\n  LoadingRetrievingData {Téléchargement des données en cours}\n  other {}\n}\n"
      },
      "pin-code-tooltip": "Votre code d'accès est indiqué sur le document que vous avez reçu avec votre CPS.<br>Si vous ne l'avez pas, contactez l’ASIP-santé / Tél. 0825 85 2000, afin qu’elle vous renvoie le code par courrier."
    }
  },
  "replacement": {
    "chosen-hemodialysis-type": {
      "hemodialysis-at-home": "A domicile",
      "hemodialysis-in-a-medicalized-dialysis-unit": "En UDM (Unité de dialyse médicalisée)",
      "hemodialysis-in-a-self-dialysis-unit": "En UAD (Unité d'auto-dialyse)",
      "hemodialysis-in-hospital-center": "En centre hospitalier"
    },
    "planned-replacement-therapy": {
      "automated-peritoneal-dialysis": "Dialyse péritonéale automatisée (DPA)",
      "conservative-treatment": "Traitement conservateur",
      "continuous-ambulatory-peritoneal-dialysis": "Dialyse péritonéale continue ambulatoire (DPCA)",
      "hemodialysis-at-home": "Hémodialyse à domicile",
      "hemodialysis-in-a-medicalized-dialysis-unit": "Hémodialyse en unité de dialyse médicalisée (UDM)",
      "hemodialysis-in-a-self-dialysis-unit": "Hémodialyse en unité d'autodialyse (UAD)",
      "hemodialysis-in-hospital-center": "Hémodialyse en centre hospitalier",
      "not-yet-defined": "Pas encore défini"
    },
    "planned-vascular-access": {
      "arteriovenous-fistula": "Fistule artério-veineuse (FAV)",
      "central-vein-catheter-tunneled-catheter": "Cathéter veineux central / cathéter tunnelisé",
      "graft": "Anse",
      "unknown": "Inconnu"
    },
    "smoking": {
      "active-smoker": "Fumeur actif",
      "former-smoker": "Ancien fumeur",
      "non-smoker": "Non fumeur",
      "unknown": "Non connu"
    },
    "smoking-cessation": {
      "in-progress": "En cours",
      "not-planned": "Non programmé",
      "planned": "Programmé"
    },
    "type-of-peritoneal-dialysis": {
      "automated-peritoneal-dialysis": "Dialyse péritonéale automatisée (DPA)",
      "continuous-ambulatory-peritoneal-dialysis": "Dialyse péritonéale continue ambulatoire (DPCA)"
    }
  },
  "surgery-reconstruction-type": {
    "complementary-lipomodelling": "Lipomodelage complémentaire",
    "deferred": "Différée",
    "exclusive-lipomodelling": "Lipomodelage exclusif",
    "flap-prosthesis": "Lambeau + prothèse",
    "immediate": "Immédiate",
    "musculo-skin-flap": "Lambeau musculo cutanée",
    "prosthesis": "Prothèse"
  },
  "surgery-type": {
    "adrenal": "Surrénales",
    "ambulatory": "Ambulatoire",
    "auxiliary-cleaning": "Curage Auxiliaire",
    "cerebral": "Cérébrale",
    "enlargement": "Elargissement",
    "external": "Externe",
    "hospitalisation": "Hospitalisation",
    "lymph-node-dissection": "Curage ganglionnaire",
    "mastectomy": "Mastectomie",
    "oncoplasty": "Oncoplastie",
    "orchiectomy": "Orchidectomie",
    "pac-installation": "Pose de PAC",
    "pamectomy": "Pamectomie",
    "prophylactic-annexectomy": "Annexectomie prophylactique",
    "prophylactic-surgery": "Chirurgie prophylactique",
    "prostatectomy": "Prostatectomie",
    "pulmonary": "Pulmonaire",
    "pulpectomy": "Pulpectomie",
    "quadrantectomy": "Quadrantectomie",
    "reconstruction": "Reconstruction",
    "sentinel-node": "Ganglion Sentinelle",
    "tumorectomy": "Tumorectomie"
  },
  "targeted-therapy-type": {
    "avastin": "Avastin",
    "herceptin": "Herceptin",
    "kadcyla": "Kadcyla",
    "olaparib-100": "Olaparib 100 mg matin et soir",
    "olaparib-150": "Olaparib 150 mg matin et soir",
    "olaparib-200": "Olaparib 200 mg matin et soir",
    "olaparib-250": "Olaparib 250 mg matin et soir",
    "olaparib-300": "Olaparib 300 mg matin et soir",
    "perjeta": "Perjeta",
    "regorafenib-stivarga-120": "Regorafenib stivarga 120 mg",
    "regorafenib-stivarga-160": "Regorafenib stivarga 160 mg",
    "regorafenib-stivarga-40": "Regorafenib stivarga 40 mg",
    "regorafenib-stivarga-80": "Regorafenib stivarga 80 mg",
    "tyverb": "Tyverb"
  },
  "task": {
    "action-taken": {
      "completed": "Marquée comme réalisée",
      "irrelevant": "Tâche ignorée",
      "not-completed": "Marquée comme non réalisée"
    },
    "actions": {
      "completed": "Marquer comme réalisée",
      "irrelevant": "Ignorer la tâche",
      "not-completed": "Marquer comme non réalisée",
      "shift-day": "Décaler à demain",
      "shift-month": "Décaler à dans un mois",
      "shift-other": "Décaler à une autre date",
      "shift-week": "Décaler à dans une semaine"
    },
    "types": {
      "administrative": "Administratif",
      "all": "Toutes",
      "anxiety-survey": "Questionnaire anxiété",
      "bio-exams-missing": "Allo labo",
      "bio-exams-received": "Biologie reçue",
      "biological-analysis": "Analyses biologiques",
      "biological-assessment-ecbu": "Examens urinaires (ECBU)",
      "biological-assessment-psa": "Bilan biologique à réaliser (Dosage PSA)",
      "call-patient": "Téléphoner au patient",
      "call-psychiatrist": "Téléphoner au psychiatre traitant",
      "call-treating-physician": "Téléphoner au médecin traitant",
      "chemotherapy-point": "Point chimio / Suite parcours",
      "collect-tls-consent": "Recueillir le consentement TLS",
      "contact-patient": "Contact patient",
      "cp-patient-appointment": "Rdv CP / patient",
      "ctcae-survey": "Questionnaire de suivi",
      "dashboard-monitoring": "Regarder le dashboard",
      "end-radiotherapy-call": "Appel fin Radiothérapie",
      "end-targeted-therapy-call": "Appel fin Thérapie ciblée",
      "external-meeting": "Réunion externe",
      "follow-up-first-results": "Suivi - 1ers résultats",
      "follow-up-monitoring": "Suivi - Surveillance",
      "follow-up-remission": "Suivi - Résultat rémission",
      "home-support": "Intervenir au domicile",
      "incoming-health-professional-call": "Appel entrant professionnel de santé",
      "incoming-patient-call": "Appel entrant patient",
      "inter-treatment-survey": "Questionnaire inter-traitement",
      "internal-meeting": "Réunion interne",
      "j-180-call": "Appel J+180",
      "j-30-call": "Appel J+30",
      "j-365-call": "Appel J+365",
      "j-90-call": "Appel J+90",
      "measure-vital-sign-blood-pressure": "Mesurer votre tension",
      "measure-vital-sign-crohn-survey": "Précisez vos symptômes via un questionnaire",
      "measure-vital-sign-rch-survey": "Précisez vos symptômes via un questionnaire",
      "measure-vital-sign-temperature": "Mesurer votre température",
      "measure-vital-sign-weight": "Mesurer votre poids",
      "medical-consultation": "Consultation médicale",
      "outgoing-health-professional-call": "Appel sortant professionnel",
      "outgoing-patient-call": "Appel sortant patient",
      "patient-visit": "Visite patiente",
      "pharmaceutical-interview": "Entretien pharmaceutique",
      "planify-follow-up-first-results": "Planifier Suivi - 1ers résultats",
      "planify-follow-up-monitoring": "Planifier Suivi - Surveillance",
      "planify-follow-up-remission": "Planifier Suivi - Résultat rémission",
      "planify-pharmaceutical-interview": "Planifier un entretien pharmaceutique",
      "ponctual-monitoring-point": "Point de suivi ponctuel",
      "post-operating-call": "Appel post-op",
      "post-operating-consultation-call": "Appel consultation post-op",
      "post-reconstruction-call": "Appel post reconstruction",
      "post-surgery-survey": "Questionnaire post-opératoire",
      "pps-control-biology": "Contrôle du PPS - Biologie",
      "pps-control-consultations": "Contrôle du PPS - Consultations",
      "pps-control-exams": "Contrôle du PPS - Examens",
      "pps-control-treatment": "Contrôle du PPS - Traitement (observance)",
      "pps-control-vital-constants": "Contrôle du PPS - Constantes vitales",
      "pps-radiotherapy-call": "Appel / Récup PPS radiothérapie",
      "pre-operating-call": "Appel pré-op / Infos suivi",
      "pre-surgery-survey": "Questionnaire pré-opératoire",
      "pre-treatment-survey": "Questionnaire pré-traitement",
      "professional-appointment": "Rdv professionnel",
      "protocol-assessment-visit": "Visite d'évaluation du protocole",
      "protocol-assessment-visit-rdv": "Prendre un RDV de visite d'évaluation du protocole",
      "quarterly-monitoring-point": "Point de suivi récurrent trimestriel",
      "re-evaluation-scanner": "Scanner de réévaluation",
      "recovery-pps-oncology": "Récup PPS oncologie",
      "recurring-monitoring-point": "Point de suivi récurrent",
      "request-cs-post-operating-date": "Demande date CS post-op",
      "room-visit": "Visite en chambre",
      "satisfaction-survey": "Questionnaire de satisfaction",
      "set-new-patient-profile": "Nouveau patient - profil à préciser",
      "start-radiotherapy-call": "Appel début Radiothérapie",
      "update-patient-birthday-reminder": "Vérifier la date de naissance du patient",
      "visit-call": "Visite / Appel"
    }
  },
  "therapeutical-area": {
    "cardio": "Cardiologie",
    "diabeto": "Diabétologie",
    "digest": "Gastro-entérologie",
    "generic": "Suivi général",
    "hepato": "Hépatologie",
    "mental": "Psychiatrie",
    "nephro": "Néphrologie",
    "onco": "Oncologie",
    "pneumo": "Pneumologie",
    "rhumato": "Rhumatologie"
  },
  "thymic-episode": {
    "duration": "{duration, plural,\n one {1 semaine}\n other {{duration} semaines}\n}\n",
    "episodeSeverity": {
      "light": "Léger",
      "medium": "Moyen",
      "severe": "Sévère"
    },
    "episodeType": {
      "depressive": "Dépressif",
      "hypomania": "Hypomanie",
      "mania": "Manie",
      "unspecified": "Épisode thymique non spécifié"
    }
  },
  "timeline": {
    "groupName": "{groupName, select,\n  other {\n    <i class=\"thumbs up outline icon\"></i>\n    <span>Autre évenement</span>\n  }\n}\n",
    "journal-event": {
      "hospitalisation-refunded-journal-event": {
        "details": "Du {visitStartDate} au {visitEndDate}"
      }
    }
  },
  "timings": {
    "1-1-a": "Tous les ans",
    "1-1-d": "Tous les jours",
    "1-1-mo": "Tous les mois",
    "1-1-wk": "Toutes les semaines",
    "1-2-a": "Tous les deux ans",
    "1-2-mo": "Tous les deux mois",
    "1-2-wk": "Toutes les deux semaines",
    "1-3-a": "Tous les trois ans",
    "1-3-mo": "Toutes les trois mois",
    "1-4-mo": "Toutes les quatres mois",
    "1-5-a": "Tous les cinq ans",
    "1-5-mo": "Tous les cinq mois",
    "1-6-mo": "Tous les six mois"
  },
  "tls-consent-status": {
    "types": {
      "all": "Tous",
      "data-only": "Recueil passif des données",
      "tls": "Télésurveillance"
    }
  },
  "treatment-protocol": {
    "abemaciclib-verzenios": "Abemaciclib - Verzenios",
    "adt-anti-androgen": "ADT + Anti-androgène",
    "adt-chemo": "ADT + Chimiothérapie",
    "atezolizumab": "Atezolizumab 1200 mg",
    "carboplatine-alimta-pembrozimulab": "Carboplatine alimta + Pembrolizumab",
    "default-chemotherapy": "Chimiothérapie",
    "default-hormonotherapy": "Hormonothérapie",
    "default-immunotherapy": "Immunothérapie",
    "default-other-follow-up-events": "Autre suivi du parcours",
    "default-radiotherapy": "Radiothérapie",
    "default-surgery": "Chirurgie",
    "default-targeted-therapy": "Thérapie ciblée",
    "olaparib-following": "Olaparib protocole renouvellement",
    "olaparib-initial": "Olaparib protocole initial",
    "pembrozimulab": "Pembrolizumab 200 mg",
    "prostatectomy-total": "Prostatectomie totale",
    "raac-gynecological-surgery": "Chirurgie Gynécologique",
    "regorafenib-stivarga-initial": "Regorafenib Stivarga initial",
    "regorafenib-stivarga-renewal": "Regorafenib Stivarga renouvellement",
    "ribociclib-kisqali": "Ribociclib - Kisqali"
  },
  "vaccines": {
    "dtPolio": "Diphtérie, Tétanos, Polio, Coqueluche",
    "pneumococcus": "Pneumocoque",
    "sarsCov2": " SARS COV 2",
    "seasonalFlu": "Grippe saisonnière",
    "yellowFever": "Fièvre jaune"
  },
  "validations": {
    "abdominal-area-declared-journal-event": {
      "value": "Le périmètre abdominal"
    },
    "activation-counts-captured-journal-event": {
      "debug-description": "TODO",
      "frames": "TODO"
    },
    "adherence-prediction-computed-journal-event": {
      "average-score-category": "TODO",
      "observance-explainers": "TODO",
      "observance-model-description": "TODO",
      "observance-score": "TODO",
      "observance-score-category": "TODO",
      "persistence-explainers": "TODO",
      "persistence-model-description": "TODO",
      "persistence-score": "TODO",
      "persistence-score-category": "TODO",
      "warnings": "TODO"
    },
    "adverse-event-declared-journal-event": {
      "adverse-event-id": "Le symptôme",
      "evaScore": "Le degré de gêne ou de douleur",
      "other-details": "Le symptôme"
    },
    "alert-processed-journal-event": {
      "action-taken": "TODO"
    },
    "alert-triggered-journal-event": {
      "alert-type": "TODO",
      "criticality": "TODO",
      "fr-localized-description": "TODO",
      "raw-omop": "TODO",
      "reason-key": "TODO",
      "source": "TODO",
      "sub-type": "TODO",
      "triggering-journal-event-id": "TODO",
      "triggering-journal-event-occurred-at": "TODO",
      "triggering-journal-event-type": "TODO",
      "triggers": "TODO"
    },
    "alertor-called-journal-event": {
      "received-response": "TODO",
      "sent-payload": "TODO",
      "status": "TODO"
    },
    "anxiety-filled-journal-event": {
      "calm": "TODO",
      "confidence": "TODO",
      "decisions": "TODO",
      "disappointment": "TODO",
      "equal-to": "TODO",
      "fail": "TODO",
      "happiness-others": "TODO",
      "happy": "TODO",
      "happy-myself": "TODO",
      "ideas-without-importance": "TODO",
      "nervous": "TODO",
      "origin-task-identifier": "TODO",
      "overcome": "TODO",
      "overreact": "TODO",
      "preoccupied": "TODO",
      "rested": "TODO",
      "satisfaction": "TODO",
      "score": "TODO",
      "security": "TODO",
      "solid-nerves": "TODO",
      "troubled-thoughts": "TODO",
      "willingness": "TODO"
    },
    "apicrypt-message-received-journal-event": {
      "apicrypt-uid": "TODO",
      "body": "TODO",
      "recipient": "TODO",
      "senders": "TODO",
      "xdm-body": "TODO"
    },
    "app-usage-consent-updated-journal-event": {
      "agreed": "TODO"
    },
    "bdi-ii-declared-journal-event": {
      "items": "TODO",
      "total": "TODO"
    },
    "bio-exam-expected-dosage-changed-journal-event": {
      "expected-dosages": "TODO"
    },
    "bio-exam-frequency-changed-journal-event": {
      "forgetting-number": "TODO",
      "frequency": "TODO",
      "index": "TODO",
      "loincs": "TODO",
      "source": "TODO"
    },
    "bio-exam-prescribed-journal-event": {
      "ald-related-comments": "TODO",
      "create-expiration-alert": "TODO",
      "custom-orders": "TODO",
      "exams": "TODO",
      "frequency": "La fréquence",
      "validity-period": "La durée de validité"
    },
    "bio-exam-results-received-journal-event": {
      "hla-cr-date": "TODO",
      "hla-id": "TODO",
      "is-draft": "TODO",
      "is-from-hprim": "TODO",
      "is-from-oru": "TODO",
      "lab": "TODO",
      "matching-page-type": "TODO",
      "normalized": "TODO",
      "oru-id": "TODO",
      "oru-status": "Le status ORU",
      "raw-oru": "TODO",
      "results": "TODO",
      "results-diff": "TODO"
    },
    "biological-act-refunded-journal-event": {
      "exemption": "TODO",
      "hospitalisation": "TODO",
      "measurements": "TODO",
      "performers": "TODO",
      "risk": "TODO"
    },
    "blood-pressure-measured-journal-event": {
      "diastolic-pressure": "TODO",
      "heart-rate": "TODO",
      "is-computed-average": "TODO",
      "occurred-at": "TODO",
      "raw-measurement": "TODO",
      "source": "TODO",
      "systolic-pressure": "TODO"
    },
    "blood-pressure-session-started-journal-event": {
      "occurred-at": "TODO"
    },
    "capillarity-blood-glucose-measured-journal-event": {
      "capillarity-blood-glucose": "La glycémie capillaire",
      "fast-insulin": "L'insuline lente",
      "insulin": "La prise d'insuline",
      "measurement-fasting": "La Mesure effectuée",
      "moment-of-the-day": "Le moment de la journée",
      "slow-insulin": "L'insuline rapide"
    },
    "care-giver-added-journal-event": {
      "address": "TODO",
      "email": "TODO",
      "first-name": "TODO",
      "last-name": "Le nom",
      "phone": "TODO",
      "role": "Le rôle"
    },
    "cnam-process-ended-journal-event": {
      "timed-transactions": "TODO"
    },
    "cnam-process-started-journal-event": {
      "cnam-adapter-name": "TODO",
      "operation-type": "TODO"
    },
    "comment-written-journal-event": {
      "comment": "TODO"
    },
    "comorbidities-and-allergies-changed-journal-event": {
      "comorbidities": "TODO",
      "ignored-comorbidities": "TODO",
      "medicated-allergies": "TODO"
    },
    "compound-survey-completed-journal-event": {
      "answers": "TODO",
      "survey-identifier": "TODO",
      "survey-raw": "TODO"
    },
    "compound-survey-frequencies-changed-journal-event": {
      "enabled-survey-frequencies": "TODO",
      "source": "TODO"
    },
    "connected-device-acquired-journal-event": {
      "device-id": "TODO",
      "device-provider": "TODO"
    },
    "connected-device-linked-journal-event": {
      "mac-address": "TODO",
      "withings-device-id": "TODO"
    },
    "connected-device-revoked-journal-event": {
      "mac-address": "TODO",
      "termination-date": "TODO"
    },
    "constant-monitoring-changed-journal-event": {
      "constants": "TODO",
      "source": "TODO"
    },
    "consultation-frequency-changed-journal-event": {
      "consultation-frequencies": "TODO",
      "source": "TODO"
    },
    "consultation-planned-journal-event": {
      "occurred-at": "TODO",
      "origin-consultation-identifier": "TODO",
      "procedure": "TODO",
      "provider": "TODO",
      "raw-siu": "TODO",
      "responsible-id": "TODO",
      "responsible-type": "TODO",
      "siu-id": "TODO",
      "status": "TODO"
    },
    "consultation-report-written-journal-event": {
      "actions-carried-out": "TODO",
      "consultation-type": "Le type de consultation",
      "occurred-at": "TODO",
      "questions": "TODO"
    },
    "crisis-plan-declared-journal-event": {
      "crisis-plan-date": "TODO",
      "depressive-actions-to-take": "TODO",
      "depressive-contacts": "TODO",
      "depressive-warnings": "TODO",
      "mental-actions-to-take": "TODO",
      "mental-contacts": "TODO",
      "mental-warnings": "TODO"
    },
    "crohn-survey-filled-journal-event": {
      "abdominal-pain": "TODO",
      "abdominal-pain-intensity": "TODO",
      "anus-symptoms": "TODO",
      "anus-symptoms-frequency": "TODO",
      "articular-pain": "TODO",
      "articular-pain-severity": "TODO",
      "eye-symptoms": "TODO",
      "eye-symptoms-painful": "TODO",
      "eye-symptoms-red-eye": "TODO",
      "eye-symptoms-sight": "TODO",
      "fever": "TODO",
      "fever-level": "TODO",
      "fistulas-embarrassment": "TODO",
      "fistulas-flow": "TODO",
      "fistulas-movement": "TODO",
      "fistulas-pain": "TODO",
      "fistulas-pain-skin": "TODO",
      "has-fistulas": "TODO",
      "mouth-ulcers": "TODO",
      "repeated-vomiting": "TODO",
      "score": "TODO",
      "skin-symptoms": "TODO",
      "stools-number": "TODO",
      "transit-blockage": "TODO",
      "weight": "TODO",
      "well-being": "TODO"
    },
    "ctcae-filled-journal-event": {
      "origin-task-identifier": "TODO",
      "sections": "TODO"
    },
    "das28-cdai-computed-journal-event": {
      "das28": "Le DAS28",
      "medic-feeling": "EVA Activité médecin",
      "nad": "Nombre d'articulations douloureuses",
      "nag": "Nombre d'articulations gonflées",
      "patient-feeling": "EVA Activité patient"
    },
    "das28-crp-computed-journal-event": {
      "crp": "CRP",
      "das28": "Le DAS28",
      "nad": "Nombre d'articulations douloureuses",
      "nag": "Nombre d'articulations gonflées",
      "patient-feeling": "EVA Activité patient"
    },
    "das28-sdai-computed-journal-event": {
      "crp": "CRP",
      "das28": "Le DAS28",
      "medic-feeling": "EVA Activité médecin",
      "nad": "Nombre d'articulations douloureuses",
      "nag": "Nombre d'articulations gonflées",
      "patient-feeling": "EVA Activité patient"
    },
    "das28-vs-computed-journal-event": {
      "das28": "Le DAS28",
      "nad": "Nombre d'articulations douloureuses",
      "nag": "Nombre d'articulations gonflées",
      "patient-feeling": "EVA Activité patient",
      "sed-rate": "Vitesse de sédimentation"
    },
    "data-sharing-consent-updated-journal-event": {
      "agreed": "TODO"
    },
    "device-ordered-journal-event": {
      "device-type": "TODO"
    },
    "diabetowise-discharge-completed-journal-event": {
      "age": "L'âge",
      "albuminuria": "L'albuminurie",
      "arglp1": "TODO",
      "chronic-renal-failure": "L'insuffisance rénale",
      "dfg": "Le DFG CKD-EPI",
      "diastolic": "La pression arthérielle diastolique",
      "do-sport": "L'activité physique",
      "dyslipidemia": "LDLc",
      "fevg": "Le FEVG",
      "first-name": "le Prénom utilisé",
      "gender": "Le sexe",
      "hba1c": "L'HbA1c",
      "heart-failure": "L'insuffisance cardiaque",
      "height": "La taille",
      "hospitalisation": "L'hospitalisation",
      "hta": "L'HTA",
      "hyperglycaemia": "L'hyperglycémie",
      "hypoglycaemia": "L'hypoglycémie",
      "idpp4": "TODO",
      "insulin": "TODO",
      "isglt2": "TODO",
      "last-name": "Le nom utilisé",
      "mcva": "La maladie cardiovasculaire athéromateuse (MCVA)",
      "met": "TODO",
      "neuropathie": "La neuropathie",
      "phone": "Le numéro de téléphone",
      "prognostic-life-threatening": "Pathologie évolutive ou menaçant le pronostic vital à court terme",
      "rac": "Le RAC",
      "severe-comorbidity": "Autres comorbidités sévères",
      "severe-hyperglycaemia": "L'hyperglycémie sévère",
      "severe-hypoglycaemia": "L'hypoglycémie sévère",
      "smoker": "Fumeur",
      "systolic": "La pression arthérielle systolique",
      "weight": "Le poids"
    },
    "diabguide-recommendation-computed-journal-event": {
      "data": "TODO",
      "warning": "TODO"
    },
    "diabguide-recommendation-started-journal-event": {
      "age": "TODO",
      "dfg": "TODO",
      "exp": "TODO",
      "fevg": "TODO",
      "hba": "TODO",
      "height": "TODO",
      "hta": "TODO",
      "ic": "TODO",
      "mcva": "TODO",
      "met": "TODO",
      "mrc": "TODO",
      "neur": "TODO",
      "oth": "TODO",
      "rac": "TODO",
      "reti": "TODO",
      "state": "TODO",
      "weight": "TODO",
      "year": "TODO"
    },
    "digital-care-declared-journal-event": {
      "happy-neuron-begin-date": "TODO",
      "happy-neuron-digital-care": "TODO",
      "happy-neuron-end-date": "TODO",
      "simple-digital-care": "TODO"
    },
    "disorder-history-declared-journal-event": {
      "number-of-depressive-episode": "TODO",
      "number-of-episode-commentary": "TODO",
      "number-of-hospitalization": "TODO",
      "number-of-hypomaniac-episode": "TODO",
      "number-of-maniac-episode": "TODO",
      "number-of-ts": "TODO",
      "number-of-ts-commentary": "TODO",
      "number-of-ts-with-thymic-episode": "TODO",
      "presence-of-rapid-cycles": "TODO",
      "presence-of-rapid-cycles-commentary": "TODO",
      "thymic-episodes": "TODO"
    },
    "dmp-access-consent-updated-journal-event": {
      "agreed": "TODO"
    },
    "dmp-document-retrieved-journal-event": {
      "cda-headers": "TODO",
      "class-code": "TODO",
      "class-code-label": "TODO",
      "doc-type": "TODO",
      "doc-type-label": "TODO",
      "mime-type": "TODO",
      "title": "TODO",
      "unique-id": "TODO"
    },
    "dmp-documents-metadata-retrieved-journal-event": {
      "documents-metadata": "TODO"
    },
    "dmp-retrieval-started-journal-event": {
      "cps-id": "TODO"
    },
    "dp-cycle-declared-journal-event": {
      "diastolic-pressure": "TODO",
      "heart-rate": "TODO",
      "night-cycle-progress": "TODO",
      "peritoneal-fluid-appearance": "TODO",
      "pocket-volume": "TODO",
      "systolic-pressure": "TODO",
      "temperature": "TODO",
      "ultrafiltration-rate": "TODO",
      "urine-output": "TODO",
      "weight": "TODO"
    },
    "drugs-and-devices-refunded-journal-event": {
      "exemption": "TODO",
      "hospitalisation": "TODO",
      "performer": "TODO",
      "prescriptor": "TODO",
      "prestations": "TODO",
      "risk": "TODO"
    },
    "etapes-prescribed-journal-event": {
      "prescribed-items": "TODO",
      "start-date": "TODO"
    },
    "fast-declared-journal-event": {
      "items": "TODO",
      "total": "TODO"
    },
    "feeling-evas-declared-journal-event": {
      "anxiety": "TODO",
      "energy": "TODO",
      "irritability": "TODO",
      "mood": "TODO",
      "sleep-duration": "TODO"
    },
    "file-uploaded-journal-event": {
      "body": "TODO",
      "file-sub-type": "Le type du fichier",
      "title": "Le titre"
    },
    "generic-prescription-uploaded-journal-event": {
      "raw-content": "TODO"
    },
    "height-measured-journal-event": {
      "height": "La taille"
    },
    "hemodialysis-session-declared-journal-event": {
      "end-arterial-diastolic-pressure": "TODO",
      "end-arterial-systolic-pressure": "TODO",
      "end-dry-weight-variation": "TODO",
      "end-heart-rate": "TODO",
      "end-output-weight": "TODO",
      "end-weight-compression-duration": "TODO",
      "middle-arterial-diastolic-pressure": "TODO",
      "middle-arterial-systolic-pressure": "TODO",
      "middle-heart-rate": "TODO",
      "middle-machine-arterial-diastolic-pressure": "TODO",
      "middle-machine-arterial-systolic-pressure": "TODO",
      "middle-machine-venous-pressure": "TODO",
      "middle-ultrafiltration-rate": "TODO",
      "middle-weight-loss": "TODO",
      "start-arterial-diastolic-pressure": "TODO",
      "start-arterial-systolic-pressure": "TODO",
      "start-dry-weight": "TODO",
      "start-heart-rate": "TODO",
      "start-real-weight": "TODO"
    },
    "hospitalisation-refunded-journal-event": {
      "exemption": "TODO",
      "performer": "TODO",
      "risk": "TODO",
      "visit-end-date": "TODO",
      "visit-source-concept": "TODO",
      "visit-source-label": "TODO",
      "visit-source-value": "TODO",
      "visit-start-date": "TODO"
    },
    "hospitalisation-risk-prediction-computed-journal-event": {
      "hospitalisation-explainers": "TODO",
      "hospitalisation-model-description": "TODO",
      "hospitalisation-score-category": "TODO",
      "score": "TODO",
      "warnings": "TODO"
    },
    "ibd-disk-survey-filled-journal-event": {
      "articular-pain-ibd": "TODO",
      "body-dissatisfaction": "TODO",
      "lack-of-energy": "TODO",
      "low-mood": "TODO",
      "score": "TODO",
      "sexual-difficulties": "TODO",
      "sleep-difficulties": "TODO",
      "social-difficulties": "TODO",
      "stomach-pain": "TODO",
      "urgent-stools-movements": "TODO",
      "work-difficulties": "TODO"
    },
    "infection-declared-journal-event": {
      "infection-type": "Le type d'infection",
      "leading-to-hospitalization": "TODO",
      "leading-to-treatment-modification": "TODO",
      "requiring-antibiotics": "TODO"
    },
    "inflammatory-eruption-declared-journal-event": {
      "details": "TODO",
      "duration": "La durée",
      "nad": "Nombre d'articulations douloureuses",
      "nag": "Nombre d'articulations gonflées",
      "occurred-at": "La date de survenue de la poussée"
    },
    "ins-retrieved-journal-event": {
      "identity": "TODO",
      "succeed": "TODO"
    },
    "inter-treatment-filled-journal-event": {
      "articular-pain-issue": "TODO",
      "articular-pain-level": "TODO",
      "articular-pain-location": "TODO",
      "articular-pain-treatment-efficient": "TODO",
      "breath": "TODO",
      "breath-issue": "TODO",
      "constipation": "TODO",
      "constipation-issue": "TODO",
      "constipation-treatment-efficient": "TODO",
      "cough": "TODO",
      "cough-issue": "TODO",
      "current-weight": "TODO",
      "dermatological-issue": "TODO",
      "dermatological-treatment-efficient": "TODO",
      "diarrhea": "TODO",
      "diarrhea-issue": "TODO",
      "fatigue": "TODO",
      "fatigue-issue": "TODO",
      "has-alerting-value": "TODO",
      "itching-issue": "TODO",
      "itching-location": "TODO",
      "muscular-pain-issue": "TODO",
      "muscular-pain-level": "TODO",
      "muscular-pain-location": "TODO",
      "muscular-pain-treatment-efficient": "TODO",
      "nausea-vomiting": "TODO",
      "nausea-vomiting-issue": "TODO",
      "origin-task-identifier": "TODO",
      "other-pain-issue": "TODO",
      "other-pain-locations": "TODO",
      "other-pain-treatment-efficient": "TODO",
      "pain": "TODO",
      "pain-issue": "TODO",
      "skin-rash-issue": "TODO",
      "skin-rash-location": "TODO",
      "temperature": "TODO",
      "temperature-issue": "TODO",
      "weight-loss": "TODO",
      "weight-loss-issue": "TODO"
    },
    "jobs-declared-journal-event": {
      "jobs": "TODO"
    },
    "kfre-five-years-computed-journal-event": {
      "age": "TODO",
      "dfg": "TODO",
      "rac": "TODO",
      "score": "TODO"
    },
    "kfre-two-years-computed-journal-event": {
      "age": "TODO",
      "dfg": "TODO",
      "rac": "TODO",
      "score": "TODO"
    },
    "lgc-consultation-report-filled-journal-event": {
      "clinical-examination-physical": "TODO",
      "clinical-examination-symptoms": "TODO",
      "conclusion-general": "TODO",
      "conclusion-next-appointment": "TODO",
      "conclusion-prescriptions": "TODO",
      "conclusion-prescriptions-delivered": "TODO",
      "general-recommendations": "TODO",
      "intercurrent-events": "TODO",
      "is-draft": "TODO",
      "occurred-at": "TODO",
      "other-additional-examinations": "TODO",
      "title": "TODO",
      "treatment-compliance-reported": "TODO",
      "treatments-prescriptions": "TODO"
    },
    "lifestyle-declared-journal-event": {
      "behaviours": "TODO"
    },
    "lomaco-document-pushed-journal-event": {
      "end-date": "TODO",
      "lomaco-document-id": "TODO",
      "start-date": "TODO"
    },
    "lomaco-patient-pushed-journal-event": {
      "lomaco-client-id": "TODO"
    },
    "lomaco-pj-document-pushed-journal-event": {
      "lomaco-pj-document-id": "TODO"
    },
    "mammography-declared-journal-event": {
      "acr-score": "Le score ACR",
      "exam-type": "L'examen"
    },
    "medical-act-frequency-changed-journal-event": {
      "medical-act-frequencies": "TODO",
      "source": "TODO"
    },
    "medical-act-refunded-journal-event": {
      "coefficient": "TODO",
      "exemption": "TODO",
      "hospitalisation": "TODO",
      "performer": "TODO",
      "procedure-source-concept": "TODO",
      "procedure-source-label": "TODO",
      "procedure-source-value": "TODO",
      "risk": "TODO"
    },
    "medical-event-journal-event": {
      "intervention-type": "Le type d'événement",
      "occurred-at": "TODO"
    },
    "medical-history-changed-journal-event": {
      "abm-classification": "TODO",
      "albuminuria": "TODO",
      "anti-cpp-date": "TODO",
      "anti-cpp-value": "TODO",
      "anticorps-anti-hbc-date": "TODO",
      "anticorps-anti-hbc-value": "TODO",
      "anticorps-anti-hbs-date": "TODO",
      "anticorps-anti-hbs-value": "TODO",
      "anticorps-anti-nucleaires-date": "TODO",
      "anticorps-anti-nucleaires-value": "TODO",
      "antigene-hbs-date": "TODO",
      "antigene-hbs-value": "TODO",
      "arglp1": "TODO",
      "assessment-realisation": "TODO",
      "assessment-result": "TODO",
      "bone-erosion": "TODO",
      "brca1": "TODO",
      "brca1-member": "TODO",
      "brca2": "TODO",
      "brca2-member": "TODO",
      "cell-cancer-type": "TODO",
      "children": "TODO",
      "chronic-bronchopneumopathy": "TODO",
      "contraception": "TODO",
      "creatinine-three-months-after-transplant": "TODO",
      "cytomegalovirus-status": "TODO",
      "dfg": "TODO",
      "diagnosis-date": "TODO",
      "diagnostic-date": "TODO",
      "diagnostic-type": "TODO",
      "diastolic": "TODO",
      "disease-activity": "TODO",
      "do-sport": "TODO",
      "donor-creatinine": "TODO",
      "donor-type": "TODO",
      "dyslipidemie-treated": "TODO",
      "electropheres-date": "TODO",
      "electropheres-value": "TODO",
      "erosion-diagnosis-date": "TODO",
      "estrogen-receptor": "TODO",
      "exp": "TODO",
      "facteur-rhumatoides-date": "TODO",
      "facteur-rhumatoides-value": "TODO",
      "familial-pancreatic-cancer": "TODO",
      "family-history-breast-cancer": "TODO",
      "family-history-breast-cancer-member": "TODO",
      "family-history-ovarian-cancer": "TODO",
      "family-history-ovarian-cancer-member": "TODO",
      "family-history-prostate-cancer": "TODO",
      "family-history-prostate-cancer-member": "TODO",
      "family-ic-background": "TODO",
      "fertility-preservation": "TODO",
      "fevg": "TODO",
      "gleason-score": "TODO",
      "has-children": "TODO",
      "hba": "TODO",
      "hba-date": "TODO",
      "heart-failure-type": "TODO",
      "height": "TODO",
      "hemato-cancer-type": "TODO",
      "hemodialysis-type": "TODO",
      "her2": "TODO",
      "hereditary-chronic-prss1-gene-mutation": "TODO",
      "histology": "TODO",
      "hormone-sensitive-cancer": "TODO",
      "housing": "TODO",
      "hta": "TODO",
      "ic": "TODO",
      "idpp4": "TODO",
      "immunological-risk": "TODO",
      "incompatible-ABO": "TODO",
      "insulin": "TODO",
      "is-following-diabetologist": "TODO",
      "isglt2": "TODO",
      "job": "TODO",
      "ki67": "TODO",
      "last-dyslipidemie": "TODO",
      "lifestyle": "TODO",
      "lung-cancer-family": "TODO",
      "main-diagnosis": "TODO",
      "marital-status": "TODO",
      "mcva": "TODO",
      "menopause": "TODO",
      "met": "TODO",
      "mrc": "TODO",
      "mrc-preexisting-transplant": "TODO",
      "mrc-stage": "TODO",
      "mutation": "TODO",
      "nephropatie": "TODO",
      "neur": "TODO",
      "non-small-cell-cancer-type": "TODO",
      "number-of-ts": "TODO",
      "nyha-stage": "TODO",
      "oncogenetic-consultation": "TODO",
      "oth": "TODO",
      "other-cancer": "TODO",
      "other-cancer-type": "TODO",
      "pancreatic-cancer-type": "TODO",
      "pancreatic-mutation": "TODO",
      "pelvic-sonogram": "TODO",
      "pr-type": "TODO",
      "pre-transplant-folder": "TODO",
      "professional-activity": "TODO",
      "progesterone-receptor": "TODO",
      "prostate-cancer-type": "TODO",
      "prostate-mutations": "TODO",
      "quantiferon-date": "TODO",
      "quantiferon-value": "TODO",
      "rac": "TODO",
      "registration-transplant-waiting-list": "TODO",
      "rejects-first-year": "TODO",
      "relapse": "TODO",
      "reti": "TODO",
      "serologie-hepatite-c-date": "TODO",
      "serologie-hepatite-c-value": "TODO",
      "serologie-hiv-date": "TODO",
      "serologie-hiv-value": "TODO",
      "side": "TODO",
      "smoker": "TODO",
      "smoking-cessation": "TODO",
      "smoking-patients": "TODO",
      "stage": "TODO",
      "state": "TODO",
      "statut-pdl1": "TODO",
      "suicidal-thoughts-start-date": "TODO",
      "suicide-risk": "TODO",
      "systolic": "TODO",
      "tnm-classification": "TODO",
      "tnm-comment": "TODO",
      "transplant-date": "TODO",
      "transplant-rank": "TODO",
      "transplanted-organ": "TODO",
      "triple-negative": "TODO",
      "underlying-disease": "TODO",
      "vaccines": "TODO",
      "weight": "TODO",
      "year": "TODO"
    },
    "medical-imaging-prescribed-journal-event": {
      "indications-ald": "TODO",
      "indications-non-ald": "TODO",
      "patient-clinical-state-ald": "TODO",
      "patient-clinical-state-non-ald": "TODO",
      "type-of-exam-ald": "TODO",
      "type-of-exam-non-ald": "TODO"
    },
    "medical-imaging-refunded-journal-event": {
      "coefficient": "TODO",
      "exemption": "TODO",
      "hospitalisation": "TODO",
      "performer": "TODO",
      "procedure-source-concept": "TODO",
      "procedure-source-label": "TODO",
      "procedure-source-value": "TODO",
      "risk": "TODO"
    },
    "medication-prescribed-journal-event": {
      "create-expiration-alert": "TODO",
      "medications": "TODO",
      "other-medications": "TODO",
      "other-medications-ald": "TODO",
      "prescriptor-identity": "TODO",
      "validity-period": "La durée de validité"
    },
    "medicines-reconciliation-changed-journal-event": {
      "educational-therapy": "TODO",
      "medicines-reconciliation": "TODO"
    },
    "mobile-passive-data-daily-snapshot-journal-event": {
      "activations": "TODO",
      "steps": "TODO",
      "visits": "TODO"
    },
    "mrc-replacement-journal-event": {
      "chosen-hemodialysis-type": "TODO",
      "dialysis-software-used": "TODO",
      "dialysis-start-date-haemodialysis": "TODO",
      "dialysis-start-date-peritoneal": "TODO",
      "functional-vascular-access": "TODO",
      "meeting-date": "TODO",
      "meeting-with-surgeon": "TODO",
      "patient-information-meeting-held": "TODO",
      "patient-lifestyle": "TODO",
      "peritoneal-catheter-placement-date": "TODO",
      "planned-dialysis-center": "TODO",
      "planned-replacement-therapy": "TODO",
      "planned-start-date": "TODO",
      "planned-vascular-access": "TODO",
      "smoking": "TODO",
      "smoking-cessation": "TODO",
      "type-of-peritoneal-dialysis": "TODO",
      "vascular-access-creation-date": "TODO"
    },
    "mrc-stage-evaluated-journal-event": {
      "mrc-stage-update": "TODO",
      "tls-suggestion": "TODO"
    },
    "notification-triggered-journal-event": {
      "is-processed": "TODO",
      "label": "TODO",
      "label-value": "TODO",
      "label-without-value": "TODO",
      "triggering-journal-event-occurred-at": "TODO"
    },
    "ok-chimio-snapshot-captured-journal-event": {
      "cure-key": "TODO",
      "protocol-uuid": "TODO",
      "snapshot": "TODO",
      "status": "TODO"
    },
    "online-consultation-report-written-journal-event": {
      "body": "Le rapport de la télé-consultation"
    },
    "oxygene-saturation-declared-journal-event": {
      "spo2": "La saturation en oxygène"
    },
    "paramedical-care-prescribed-journal-event": {
      "care-ald": "TODO",
      "care-non-ald": "TODO"
    },
    "patient-administrative-data-updated-journal-event": {
      "information-changes": "TODO"
    },
    "patient-chat-message-sent-journal-event": {
      "body": "TODO",
      "read-by-patient-at": "TODO"
    },
    "patient-disenrolled-journal-event": {
      "moved-journal-events": "TODO",
      "reason": "La raison de désinscription",
      "target-patient-id": "TODO"
    },
    "patient-enrolled-journal-event": {
      "follow-up-reason": "TODO"
    },
    "patient-information-transmitted-journal-event": {
      "information": "TODO"
    },
    "personal-notes-changed-journal-event": {
      "note": "TODO"
    },
    "phq-nine-declared-journal-event": {
      "items": "TODO",
      "total": "TODO"
    },
    "post-surgery-survey-filled-journal-event": {
      "activity-recovery": "TODO",
      "bleeding-on-wound": "TODO",
      "calf-pain": "TODO",
      "diastolic-blood-pressure": "TODO",
      "difficulties-to-urinate": "TODO",
      "digestive-recovery": "TODO",
      "eating-recovery": "TODO",
      "has-alerting-value": "TODO",
      "nausea-or-vomiting": "TODO",
      "origin-task-identifier": "TODO",
      "pain-since-back-home": "TODO",
      "pulse": "TODO",
      "score": "TODO",
      "systolic-blood-pressure": "TODO",
      "temperature-level": "TODO",
      "wound-flow": "TODO",
      "wound-inflammation": "TODO"
    },
    "pr-articulations-counted-journal-event": {
      "nad": "Nombre d'articulations douloureuses",
      "nag": "Nombre d'articulations gonflées"
    },
    "pr-feeling-eva-medic-declared-journal-event": {
      "feeling": "TODO"
    },
    "pr-feeling-eva-patient-declared-journal-event": {
      "feeling": "TODO"
    },
    "pre-surgery-survey-filled-journal-event": {
      "ambulatory-procedure": "TODO",
      "attendant-for-return": "TODO",
      "bought-painkillers-and-antinauseant": "TODO",
      "has-alerting-value": "TODO",
      "origin-task-identifier": "TODO",
      "score": "TODO",
      "trust-person-survey-filled": "TODO",
      "usual-treatment-guidelines": "TODO"
    },
    "pre-treatment-filled-journal-event": {
      "articular-pain-issue": "TODO",
      "articular-pain-level": "TODO",
      "articular-pain-location": "TODO",
      "articular-pain-treatment-efficient": "TODO",
      "breath": "TODO",
      "breath-issue": "TODO",
      "constipation": "TODO",
      "constipation-issue": "TODO",
      "constipation-treatment-efficient": "TODO",
      "cortisone": "TODO",
      "cortisone-dosage-gt20": "TODO",
      "cough": "TODO",
      "cough-issue": "TODO",
      "current-weight": "TODO",
      "dermatological-issue": "TODO",
      "dermatological-treatment-efficient": "TODO",
      "diarrhea": "TODO",
      "diarrhea-issue": "TODO",
      "fatigue": "TODO",
      "fatigue-issue": "TODO",
      "has-alerting-value": "TODO",
      "itching-issue": "TODO",
      "itching-location": "TODO",
      "muscular-pain-issue": "TODO",
      "muscular-pain-level": "TODO",
      "muscular-pain-location": "TODO",
      "muscular-pain-treatment-efficient": "TODO",
      "nausea-vomiting": "TODO",
      "nausea-vomiting-issue": "TODO",
      "origin-task-identifier": "TODO",
      "other-pain-issue": "TODO",
      "other-pain-locations": "TODO",
      "other-pain-treatment-efficient": "TODO",
      "pac-flowing": "TODO",
      "pac-healing": "TODO",
      "pac-inflammatory": "TODO",
      "pac-painful": "TODO",
      "pain": "TODO",
      "pain-issue": "TODO",
      "radiotherapy": "TODO",
      "skin-rash-issue": "TODO",
      "skin-rash-location": "TODO",
      "temperature": "TODO",
      "temperature-issue": "TODO",
      "weight-loss": "TODO",
      "weight-loss-issue": "TODO"
    },
    "pro-irc-status-updated-journal-event": {
      "included": "TODO",
      "pro-irc-start-date": "TODO"
    },
    "profiler-retrieved-journal-event": {
      "pps": "TODO",
      "profiles": "TODO"
    },
    "qids-declared-journal-event": {
      "items": "TODO",
      "total": "TODO"
    },
    "rch-survey-filled-journal-event": {
      "anal-incontinence": "TODO",
      "anal-incontinence-frequency": "TODO",
      "articular-pain": "TODO",
      "articular-pain-severity": "TODO",
      "average-stools-number": "TODO",
      "blood-in-stool": "TODO",
      "blood-in-stool-frequency": "TODO",
      "eye-symptoms": "TODO",
      "eye-symptoms-painful": "TODO",
      "eye-symptoms-red-eye": "TODO",
      "eye-symptoms-sight": "TODO",
      "fever": "TODO",
      "fever-level": "TODO",
      "immediate-stool": "TODO",
      "immediate-stool-urgency": "TODO",
      "mouth-ulcers": "TODO",
      "score": "TODO",
      "skin-symptoms": "TODO",
      "weight": "TODO",
      "well-being": "TODO"
    },
    "recursive-task-planned-journal-event": {
      "end-date": "TODO",
      "occurred-at": "TODO",
      "origin-task-identifier": "TODO",
      "processed-at": "TODO",
      "processing-journal-event-type": "TODO",
      "remind-responsible": "TODO",
      "responsible-id": "TODO",
      "responsible-type": "TODO",
      "task-type": "TODO",
      "time-frequency-unit": "TODO",
      "time-frequency-value": "TODO"
    },
    "reimbursements-retrieved-journal-event": {
      "success": "TODO",
      "version": "TODO"
    },
    "respiratory-rate-measured-journal-event": {
      "respiratory-rate": "La fréquence respiratoire"
    },
    "spirometer-associated-journal-event": {
      "serial-number": "TODO"
    },
    "step-counts-captured-journal-event": {
      "debug-description": "TODO",
      "frames": "TODO"
    },
    "stools-number-declared-journal-event": {
      "value": "Le nombre de selles"
    },
    "survey-completed-journal-event": {
      "form-id": "TODO",
      "linked-journal-event-ids": "TODO",
      "raw-inputs": "TODO"
    },
    "survey-requested-journal-event": {
      "expire-at": "TODO",
      "form-id": "TODO",
      "visible-only-by": "TODO"
    },
    "task-planned-journal-event": {
      "expired-at": "TODO",
      "last-hprim-date": "TODO",
      "link": "TODO",
      "models": "TODO",
      "occurred-at": "TODO",
      "origin-task-identifier": "TODO",
      "processing-journal-event-type": "TODO",
      "remind-responsible": "TODO",
      "responsible-id": "L'id du responsable",
      "responsible-type": "Le type du responsable",
      "task-type": "Le titre"
    },
    "task-processed-journal-event": {
      "action-taken": "TODO",
      "process-older-tasks": "TODO"
    },
    "temperature-measured-journal-event": {
      "temperature": "La température"
    },
    "therapeutic-assistance-session-completed-journal-event": {
      "diagnostic": "TODO",
      "education-subjects": "TODO",
      "name": "Le nom",
      "patient-questions": "TODO",
      "situation": "La situation",
      "wrap-up": "TODO"
    },
    "three-months-goals-journal-event": {
      "goals": "TODO"
    },
    "thymic-episode-occurred-journal-event": {
      "commentary": "TODO",
      "episode-duration": "La durée de l'épisode en semaine",
      "episode-severity": "TODO",
      "episode-type": "Type d'épisode",
      "hospitalization": "L'hospitalisation",
      "ts-presence": "La présence d'une TS",
      "with-anxious-distress": "TODO",
      "with-atypical-characteristics": "TODO",
      "with-catatonia": "TODO",
      "with-melancholic-characteristics": "TODO",
      "with-mixed-characteristics": "TODO",
      "with-onset-during-peripartum": "TODO",
      "with-psychotic-congruent-with-mood": "TODO",
      "with-psychotic-not-congruent-with-mood": "TODO"
    },
    "tls-consent-updated-journal-event": {
      "agreed": "TODO"
    },
    "tls-prescribed-journal-event": {
      "current-weight": "Poids du patient au moment de la prescription",
      "invoiced": "TODO",
      "prescription-reason": "Raison de la prescription",
      "start-date": "Date de début"
    },
    "tls-trial-period-journal-event": {
      "started-date": "TODO",
      "status": "TODO"
    },
    "tls-trial-period-validated-journal-event": {
      "validated": "TODO"
    },
    "toxicity-prediction-computed-journal-event": {
      "score": "TODO",
      "toxicity-explainers": "TODO",
      "toxicity-model-description": "TODO",
      "toxicity-score-category": "TODO",
      "warnings": "TODO"
    },
    "treatment-history-changed-journal-event": {
      "chemotherapies": "TODO",
      "hormonotherapies": "TODO",
      "immunotherapies": "TODO",
      "oncologies": "TODO",
      "other-follow-up-events": "TODO",
      "protocols": "TODO",
      "radiotherapies": "TODO",
      "surgery-surgeries": "TODO",
      "targeted-therapies": "TODO"
    },
    "treatment-prescription-changed-journal-event": {
      "ignored-atc-codes": "TODO",
      "prescriptions": "TODO"
    },
    "vaccines-refunded-journal-event": {
      "exemption": "TODO",
      "hospitalisation": "TODO",
      "performer": "TODO",
      "prescriptor": "TODO",
      "prestations": "TODO",
      "risk": "TODO"
    },
    "vems-declared-journal-event": {
      "demm": "Le DEMM",
      "source": "La source",
      "value1": "Le VEMS",
      "value2": "Le VEMS",
      "value3": "Le VEMS"
    },
    "visits-location-counts-captured-journal-event": {
      "debug-description": "TODO",
      "frames": "TODO"
    },
    "weight-measured-journal-event": {
      "source": "TODO",
      "weight": "Le poids"
    },
    "ymrs-declared-journal-event": {
      "items": "TODO",
      "total": "TODO"
    }
  },
  "vital-sign": {
    "abdominal-area": {
      "dashboard": "Périmètre abdominal",
      "long-description": "Périmètre abdominal",
      "short-description": "Périmètre abdominal"
    },
    "adverse-events": {
      "dashboard": "Symptômes",
      "long-description": "Symptôme",
      "short-description": "Symptôme"
    },
    "blood-pressure": {
      "long-description": "Tension artérielle",
      "short-description": "Tension"
    },
    "capillarity-blood-glucose": {
      "dashboard": "Glycémie capillaire",
      "long-description": "Glycémie capillaire",
      "short-description": "Glycémie capillaire"
    },
    "crohn-survey": {
      "dashboard": "Quest. Crohn",
      "long-description": "Questionnaire Crohn",
      "short-description": "Symptômes",
      "task-description": "Déclarer vos symptômes"
    },
    "das28-cdai": {
      "dashboard": "CDAI",
      "long-description": "CDAI",
      "short-description": "CDAI"
    },
    "das28-crp": {
      "dashboard": "DAS28 CRP",
      "long-description": "DAS28 CRP",
      "short-description": "DAS28 CRP"
    },
    "das28-sdai": {
      "dashboard": "SDAI",
      "long-description": "SDAI",
      "short-description": "SDAI"
    },
    "das28-vs": {
      "dashboard": "DAS28 VS",
      "long-description": "DAS28 VS",
      "short-description": "DAS28 VS"
    },
    "dp-cycle": {
      "dashboard": "Cycle DP",
      "long-description": "Cycle dialyse péritonéale",
      "short-description": "Cycle DP"
    },
    "eva": {
      "long-description": "Ressenti Patient (EVA)",
      "short-description": "Ressenti patient"
    },
    "fast": {
      "long-description": "Questionnaire FAST",
      "short-description": "FAST"
    },
    "hemodialysis-session": {
      "dashboard": "Séance hémodialyse",
      "long-description": "Séance hémodialyse",
      "short-description": "Séance hémodialyse"
    },
    "ibd-disk-survey": {
      "dashboard": "Quest. IBD-Disk",
      "long-description": "Questionnaire IBD-Disk",
      "short-description": "Qualité de vie",
      "task-description": "Mesurer votre qualité de vie"
    },
    "infection": {
      "dashboard": "Infection",
      "long-description": "Infection",
      "short-description": "Infection"
    },
    "inflammatory-eruption": {
      "dashboard": "Suivi poussées",
      "long-description": "Suivi poussées",
      "short-description": "Poussée inflammatoire aigüe"
    },
    "kfre-five-years": {
      "dashboard": "KFRE 5 ans",
      "long-description": "KFRE 5 ans",
      "short-description": "KFRE 5 ans"
    },
    "kfre-two-years": {
      "dashboard": "KFRE 2 ans",
      "long-description": "KFRE 2 ans",
      "short-description": "KFRE 2 ans"
    },
    "mammography-and-mri": {
      "long-description": "Score mammographie et Score IRM",
      "short-description": "Mammographie ou IRM"
    },
    "medic-feeling": {
      "dashboard": "EVA Activité médecin",
      "long-description": "EVA Activité médecin",
      "short-description": "EVA Activité médecin"
    },
    "nad-nag": {
      "long-description": "NAD NAG",
      "short-description": "NAD NAG"
    },
    "oxygene-saturation": {
      "dashboard": "SpO2",
      "long-description": "Saturation en oxygène",
      "short-description": "Saturation en oxygène"
    },
    "patient-feeling": {
      "dashboard": "EVA Activité patient",
      "long-description": "EVA Activité patient",
      "short-description": "Ressenti de la maladie"
    },
    "qids": {
      "long-description": "Questionnaire QIDS",
      "short-description": "QIDS"
    },
    "rch-survey": {
      "dashboard": "Quest. RCH",
      "long-description": "Questionnaire RCH",
      "short-description": "Symptômes",
      "task-description": "Déclarer vos symptômes"
    },
    "respiratory-rate": {
      "dashboard": "Fréq. respiratoire",
      "long-description": "Fréquence respiratoire",
      "short-description": "Fréquence respiratoire"
    },
    "stools-number": {
      "dashboard": "Nombre de selles",
      "long-description": "Nombre de selles",
      "short-description": "Nombre de selles"
    },
    "temperature": {
      "dashboard": "Température",
      "long-description": "Température",
      "short-description": "Température"
    },
    "vems-demm": {
      "long-description": "EFR-VEMS (FEV1)",
      "short-description": "EFR-VEMS (FEV1)"
    },
    "weight": {
      "dashboard": "Poids / IMC",
      "long-description": "Poids",
      "short-description": "Poids"
    },
    "ymrs": {
      "long-description": "Questionnaire YMRS",
      "short-description": "YMRS"
    }
  }
}]];